import * as rcc from "./RCConst";

import * as gbc from "../../GB/GBConst";
import {
    getGenderPlural
} from "../../GB/GBUtil";
import {RS} from "../../../data/strings/global";
import * as SC from "../../../data/strings/RCStringConst";

/* NOTE: Most of these mappings should really be in a database read in from a server, but we don't
   have a server and don't have much time and these methods were already here before they changed the
   number of indicators, target populations, etc. 10 fold...
*/

/* "Constructor" methods */

export function createAppState() {

    return ({
        [rcc.drawerID_AS_C]          : "",
        [rcc.drawerOpen_AS_C]        : false,
        [rcc.failedToLoad_AS_C]      : false,
        [rcc.language_AS_C]          : localStorage.getItem("userLanguage") ? Number(localStorage.getItem("userLanguage")) : gbc.language.english,
        [rcc.sideBarOpen_AS_C]       : false,
        [rcc.answer1Byte_AS_C]       : 0,
        [rcc.answer2Byte_AS_C]       : rcc.precisionAQ2A,
        [rcc.groupObjList_AS_C]      : [],
        [rcc.indicatorObjList_AS_C]  : [],
        [rcc.selectedIndCurrID_AS_C] : 0,
        [rcc.targPopObjList_AS_C]    : [],
    });

}

export function createIndObj(name, mstID, targPopCurrID, groupCurrID) {

    return ({
        [rcc.analyzeBool_I_C] : false,
        [rcc.targPop_I_TP_C]  : {
            [rcc.currID_I_TP_C]       : targPopCurrID,
            [rcc.type_I_TP_C]         : rcc.defaultTargPop,
            [rcc.labParams_I_TP_LP_C] : {
                [rcc.startAge_I_TP_LP_C]  : RS(SC.GB_stNA),
                [rcc.endAge_I_TP_LP_C]    : RS(SC.GB_stNA),
                [rcc.refPeriod_I_TP_LP_C] : RS(SC.GB_stNA),
                [rcc.gender_I_TP_LP_C]    : RS(SC.GB_stNA),
            },
            [rcc.value_I_TP_C] : 0,
            [rcc.customStr_I_TP_C] : RS(SC.GB_stCustomTargPop),
        },

        [rcc.numIntervHHs_I_C] : 0,
        [rcc.groupCurrID_I_C]        : groupCurrID,
        [rcc.mstID_I_C]              : mstID,
        [rcc.name_I_C]               : name,
        [rcc.precInputs_I_PI_C]         : {
            [rcc.desNumHHsNum_I_PI_C]     : 0,
            [rcc.estFreqPerc_I_PI_C]      : 0,
            [rcc.desiredPrecNum_I_PI_C]   : 0,
            [rcc.designEffectNum_I_PI_C]  : 0,
        },
        [rcc.propHHResponseRate_I_C] : 0,
        [rcc.powerChangeInputs_I_PC_C]  : {
            [rcc.desNumHHsPerSurveyNum_I_PC_C]     : 0,
            [rcc.estFreqBaselinePerc_I_PC_C]       : 0,
            [rcc.estFreqEndlinePerc_I_PC_C]        : 0,
            [rcc.designEffectNum_I_PC_C]           : 0,
        },
        [rcc.custom_I_C] : false,
    });

}

export function createTargPopObj(name, paramName, mstID) {

    return ({
        [rcc.mstID_TP_C]       : mstID,
        [rcc.name_TP_C]        : name,
        [rcc.paramName_TP_C]   : paramName,
    });

}

export function createGroupObj(name, mstID) {

    return ({
        [rcc.mstID_G_C]         : mstID,
        [rcc.name_G_C]          : name,
        [rcc.panelExpanded_G_C] : true,
    });

}

export function getDefIndName(indCurrID) {

    let indName;

    switch (indCurrID) {

        case rcc.demandFamPlanSatCurrID :
            indName = RS(SC.GB_stDemandFamPlanSat);
            break;

        case rcc.CPR_CurrID :
            indName = RS(SC.GB_stCPR);
            break;

        case rcc.usingContraceptCurrID :
            indName = RS(SC.GB_stUsingContracept);
            break;

        case rcc.famPlanDiscCurrID :
            indName = RS(SC.GB_stFamPlanDisc);
            break;

        case rcc.ANC_CurrID :
            indName = RS(SC.GB_stANC);
            break;

        case rcc.contentANC_CurrID :
            indName = RS(SC.GB_stContentANC);
            break;

        case rcc.accompANC_VisitCurrID :
            indName = RS(SC.GB_stAccompANC_Visit);
            break;

        case rcc.partnerANC_ConsultCurrID :
            indName = RS(SC.GB_stPartnerANC_Consult);
            break;

        case rcc.HIV_TestANCCurrID :
            indName = RS(SC.GB_stHIV_TestANC);
            break;

        case rcc.HIV_CounsANCCurrID :
            indName = RS(SC.GB_stHIV_CounsANC);
            break;

        case rcc.ITN_CovPregWCurrID :
            indName = RS(SC.GB_stITN_CovPregW);
            break;

        case rcc.IPTpCurrID :
            indName = RS(SC.GB_stIPTp);
            break;

        case rcc.ironAcidFolicSuppPregWCurrID :
            indName = RS(SC.GB_stIronAcidFolicSuppPregW);
            break;

        case rcc.neonatalTetanusProtectPregWCurrID :
            indName = RS(SC.GB_stNeonatalTetanusProtectPregW);
            break;

        case rcc.SBA_CurrID :
            indName = RS(SC.GB_stSBA);
            break;

        case rcc.institutionalDelivCurrID :
            indName = RS(SC.GB_stInstitutionalDeliv);
            break;

        case rcc.partnerLabourDeliveryCurrID :
            indName = RS(SC.GB_stPartnerLabourDelivery);
            break;

        case rcc.C_SectionCurrID :
            indName = RS(SC.GB_stC_Section);
            break;

        case rcc.postnatalVisitMotherCurrID :
            indName = RS(SC.GB_stPostnatalVisitMother);
            break;

        case rcc.postnatalVisitNewbornCurrID :
            indName = RS(SC.GB_stPostnatalVisitNewborn);
            break;

        case rcc.thermalCordCareCurrID :
            indName = RS(SC.GB_stThermalCordCare);
            break;

        case rcc.skinToSkinCareCurrID :
            indName = RS(SC.GB_stSkinToSkinCare);
            break;

        case rcc.BCG_CurrID :
            indName = RS(SC.GB_stBCG);
            break;

        case rcc.measlesImmunCurrID :
            indName = RS(SC.GB_stMeaslesImmun          );
            break;

        case rcc.pentaDPT3ImmunCurrID :
            indName = RS(SC.GB_stPentaDPT3Immun);
            break;

        case rcc.pneumoImmunCurrID :
            indName = RS(SC.GB_stPneumoImmun);
            break;

        case rcc.rotavirusImmunCurrID :
            indName = RS(SC.GB_stRotavirusImmun);
            break;

        case rcc.ITN_ChildrenU5CurrID :
            indName = RS(SC.GB_stITN_ChildrenU5);
            break;

        case rcc.episodeFeverCurrID :
            indName = RS(SC.GB_stEpisodeFever);
            break;

        case rcc.episodeDiarCurrID :
            indName = RS(SC.GB_stEpisodeDiar);
            break;

        case rcc.episodeSuspectPneumCurrID :
            indName = RS(SC.GB_stEpisodeSuspectPneum);
            break;

        case rcc.careSeekFeverCurrID :
            indName = RS(SC.GB_stCareSeekFever);
            break;

        case rcc.malariaFirstLineTreatmentCurrID :
            indName =  RS(SC.GB_stMalariaFirstLineTreatment);
            break;

        case rcc.careSeekDiarCurrID :
            indName = RS(SC.GB_stCareSeekDiar);
            break;

        case rcc.careSeekSuspectPneumCurrID :
            indName = RS(SC.GB_stCareSeekSuspectPneum);
            break;

        case rcc.ORS_TreatDiarCurrID :
            indName = RS(SC.GB_stORS_TreatDiar);
            break;

        case rcc.zincTreatDiarCurrID :
            indName = RS(SC.GB_stZincTreatDiar);
            break;

        case rcc.ORS_ZincTreatDiarCurrID :
            indName = RS(SC.GB_stORS_ZincTreatDiar);
            break;

        case rcc.antimalarialTreatCurrID :
            indName = RS(SC.GB_stAntimalarialTreat);
            break;

        case rcc.childEverBreastfedCurrID :
            indName = RS(SC.GB_stChildEverBreastfed);
            break;

        case rcc.exclBF_LT6MoCurrID :
            indName = RS(SC.GB_stExclBF_LT6Mo);
            break;

        case rcc.earlyInitBFCurrID :
            indName = RS(SC.GB_stEarlyInitBF);
            break;

        case rcc.contBF_At1YrCurrID :
            indName = RS(SC.GB_stContBF_At1Yr);
            break;

        case rcc.contBF_At2YrCurrID :
            indName = RS(SC.GB_stContBF_At2Yr);
            break;

        case rcc.apprFeedPractCurrID :
            indName = RS(SC.GB_stApprFeedPract);
            break;

        case rcc.vitASuppCurrID :
            indName = RS(SC.GB_stVitASupp);
            break;

        case rcc.introSolidSoftFoodsCurrID :
            indName = RS(SC.GB_stIntroSolidSoftFoods);
            break;

        case rcc.minDietDiversityCurrID :
            indName = RS(SC.GB_stMinDietDiversity);
            break;

        case rcc.minMealFrequencyCurrID :
            indName = RS(SC.GB_stMinMealFrequency);
            break;

        case rcc.minAcceptableDietCurrID :
            indName = RS(SC.GB_stMinAcceptableDiet);
            break;

        case rcc.underweightPrevChildrenCurrID :
            indName = RS(SC.GB_stUnderweightPrevChildren);
            break;

        case rcc.stuntingPrevChildrenCurrID :
            indName = RS(SC.GB_stStuntingPrevChildren);
            break;

        case rcc.wastingPrevChildrenCurrID :
            indName = RS(SC.GB_stWastingPrevChildren);
            break;

        case rcc.overweightPrevChildrenCurrID :
            indName = RS(SC.GB_stOverweightPrevChildren);
            break;

        case rcc.availITNsCurrID :
            indName = RS(SC.GB_stAvailITNs);
            break;

        case rcc.ITN_HH_CovCurrID :
            indName = RS(SC.GB_stITN_HH_Cov);
            break;

        case rcc.IRS_CurrID :
            indName = RS(SC.GB_stIRS);
            break;

        case rcc.impDrinkWaterSrcCurrID :
            indName = RS(SC.GB_stImpDrinkWaterSrc);
            break;

        case rcc.impDrinkWaterSrcHH_CovCurrID :
            indName = RS(SC.GB_stImpDrinkWaterSrcHH_Cov);
            break;

        case rcc.impSanitFacilCurrID :
            indName = RS(SC.GB_stImpSanitFacil);
            break;

        case rcc.impSaniFacil_HH_CovCurrID :
            indName = RS(SC.GB_stImpSaniFacil_HH_Cov);
            break;

        case rcc.safeDisposalChildStoolsCurrID :
            indName = RS(SC.GB_stSafeDisposalChildStools);
            break;

        case rcc.wealthIdxQuintileCurrID :
            indName = RS(SC.GB_stWealthIdxQuintile);
            break;

        case rcc.birthRegistrationCurrID :
            indName = RS(SC.GB_stBirthRegistration);
            break;

        case rcc.earlyFirstMarriageUnionCurrID :
            indName = RS(SC.GB_stEarlyFirstMarriageUnion);
            break;

        case rcc.youngW_MarriedUnionCurrID :
            indName = RS(SC.GB_stYoungW_MarriedUnion);
            break;

        case rcc.earlyChildbearingCurrID :
            indName = RS(SC.GB_stEarlyChildbearing);
            break;

        case rcc.prevFGM_W_CurrID :
            indName = RS(SC.GB_stPrevFGM_W);
            break;

        case rcc.prevFGM_GirlsCurrID :
            indName = RS(SC.GB_stPrevFGM_Girls);
            break;

        case rcc.multiSexPartnersCurrID :
            indName = RS(SC.GB_stMultiSexPartners);
            break;

        case rcc.condomUseLastSexMultiSexPartnersCurrID :
            indName = RS(SC.GB_stCondomUseLastSexMultiSexPartners);
            break;

        case rcc.sexNonRegPartnersCurrID :
            indName = RS(SC.GB_stSexNonRegPartners);
            break;

        case rcc.condomUseNonRegPartnersCurrID :
            indName = RS(SC.GB_stCondomUseNonRegPartners);
            break;

        case rcc.neverMarriedChildrenNotSexActiveCurrID :
            indName = RS(SC.GB_stNeverMarriedChildrenNotSexActive);
            break;

        case rcc.sexBefore15YrsCurrID :
            indName = RS(SC.GB_stSexBefore15Yrs);
            break;

        case rcc.sexActiveChildrenPastYearCurrID :
            indName = RS(SC.GB_stSexActiveChildrenPastYear);
            break;

        case rcc.HIV_TestLast12MoResultsKnownCurrID :
            indName = RS(SC.GB_stHIV_TestLast12MoResultsKnown);
            break;

        case rcc.employmentLast7DaysCurrID :
            indName = RS(SC.GB_stEmploymentLast7Days);
            break;

        case rcc.employmentLast12MoCurrID :
            indName = RS(SC.GB_stEmploymentLast12Mo);
            break;

        case rcc.cashEarningsCurrID :
            indName = RS(SC.GB_stCashEarnings);
            break;

        case rcc.bankAccountsCurrID :
            indName = RS(SC.GB_stBankAccounts);
            break;

        case rcc.ownershipMobilePhonesCurrID :
            indName =RS(SC.GB_stOwnershipMobilePhones);
            break;

        case rcc.mobilePhoneFinancTransactionsCurrID :
            indName = RS(SC.GB_stMobilePhoneFinancTransactions);
            break;

        case rcc.ctrlOverOwnIncomeCurrID :
            indName = RS(SC.GB_stCtrlOverOwnIncome);
            break;

        case rcc.ctrlOverPartnerEarningsCurrID :
            indName = RS(SC.GB_stCtrlOverPartnerEarnings);
            break;

        case rcc.decisMakingOwnHlthCareCurrID :
            indName = RS(SC.GB_stDecisMakingOwnHlthCare);
            break;

        case rcc.leavHouseWCurrID :
            indName = RS(SC.GB_stLeavHouseW);
            break;  

        default :
            indName = "";
            break;

    }

    return indName;

}

export function getDefIndMstID(indCurrID) {

    let indMstID;

    switch (indCurrID) {

        case rcc.demandFamPlanSatCurrID :
            indMstID = rcc.demandFamPlanSatMstID;
            break;

        case rcc.CPR_CurrID :
            indMstID = rcc.CPR_MstID;
            break;

        case rcc.usingContraceptCurrID :
            indMstID = rcc.usingContraceptMstID;
            break;

        case rcc.famPlanDiscCurrID :
            indMstID = rcc.famPlanDiscMstID;
            break;

        case rcc.ANC_CurrID :
            indMstID = rcc.ANC_MstID;
            break;

        case rcc.contentANC_CurrID :
            indMstID = rcc.contentANC_MstID;
            break;

        case rcc.accompANC_VisitCurrID :
            indMstID = rcc.accompANC_VisitMstID;
            break;

        case rcc.partnerANC_ConsultCurrID :
            indMstID = rcc.partnerANC_ConsultMstID;
            break;

        case rcc.HIV_TestANCCurrID :
            indMstID = rcc.HIV_TestANCMstID;
            break;

        case rcc.HIV_CounsANCCurrID :
            indMstID = rcc.HIV_CounsANCMstID;
            break;

        case rcc.ITN_CovPregWCurrID :
            indMstID = rcc.ITN_CovPregWMstID;
            break;

        case rcc.IPTpCurrID :
            indMstID = rcc.IPTpMstID;
            break;

        case rcc.ironAcidFolicSuppPregWCurrID :
            indMstID = rcc.ironAcidFolicSuppPregWMstID;
            break;

        case rcc.neonatalTetanusProtectPregWCurrID :
            indMstID = rcc.neonatalTetanusProtectPregWMstID;
            break;

        case rcc.SBA_CurrID :
            indMstID = rcc.SBA_MstID;
            break;

        case rcc.institutionalDelivCurrID :
            indMstID = rcc.institutionalDelivMstID;
            break;

        case rcc.partnerLabourDeliveryCurrID :
            indMstID = rcc.partnerLabourDeliveryMstID;
            break;

        case rcc.C_SectionCurrID :
            indMstID = rcc.C_SectionMstID;
            break;

        case rcc.postnatalVisitMotherCurrID :
            indMstID = rcc.postnatalVisitMotherMstID;
            break;

        case rcc.postnatalVisitNewbornCurrID :
            indMstID = rcc.postnatalVisitNewbornMstID;
            break;

        case rcc.thermalCordCareCurrID :
            indMstID = rcc.thermalCordCareMstID;
            break;

        case rcc.skinToSkinCareCurrID :
            indMstID = rcc.skinToSkinCareMstID;
            break;

        case rcc.BCG_CurrID :
            indMstID = rcc.BCG_MstID;
            break;

        case rcc.measlesImmunCurrID :
            indMstID = rcc.measlesImmunMstID;
            break;

        case rcc.pentaDPT3ImmunCurrID :
            indMstID = rcc.pentaDPT3ImmunMstID;
            break;

        case rcc.pneumoImmunCurrID :
            indMstID = rcc.pneumoImmunMstID;
            break;

        case rcc.rotavirusImmunCurrID :
            indMstID = rcc.rotavirusImmunMstID;
            break;

        case rcc.ITN_ChildrenU5CurrID :
            indMstID = rcc.ITN_ChildrenU5MstID;
            break;

        case rcc.episodeFeverCurrID :
            indMstID = rcc.episodeFeverMstID;
            break;

        case rcc.episodeDiarCurrID :
            indMstID = rcc.episodeDiarMstID;
            break;

        case rcc.episodeSuspectPneumCurrID :
            indMstID = rcc.episodeSuspectPneumMstID;
            break;

        case rcc.careSeekFeverCurrID :
            indMstID = rcc.careSeekFeverMstID;
            break;

        case rcc.malariaFirstLineTreatmentCurrID :
            indMstID = rcc.malariaFirstLineTreatmentMstID;
            break;

        case rcc.careSeekDiarCurrID :
            indMstID = rcc.careSeekDiarMstID;
            break;

        case rcc.careSeekSuspectPneumCurrID :
            indMstID = rcc.careSeekSuspectPneumMstID;
            break;

        case rcc.ORS_TreatDiarCurrID :
            indMstID = rcc.ORS_TreatDiarMstID;
            break;

        case rcc.zincTreatDiarCurrID :
            indMstID = rcc.zincTreatDiarMstID;
            break;

        case rcc.ORS_ZincTreatDiarCurrID :
            indMstID = rcc.ORS_ZincTreatDiarMstID;
            break;

        case rcc.antimalarialTreatCurrID :
            indMstID = rcc.antimalarialTreatMstID;
            break;

        case rcc.childEverBreastfedCurrID :
            indMstID = rcc.childEverBreastfedMstID;
            break;

        case rcc.exclBF_LT6MoCurrID :
            indMstID = rcc.exclBF_LT6MoMstID;
            break;

        case rcc.earlyInitBFCurrID :
            indMstID = rcc.earlyInitBFMstID;
            break;

        case rcc.contBF_At1YrCurrID :
            indMstID = rcc.contBF_At1YrMstID;
            break;

        case rcc.contBF_At2YrCurrID :
            indMstID = rcc.contBF_At2YrMstID;
            break;

        case rcc.apprFeedPractCurrID :
            indMstID = rcc.apprFeedPractMstID;
            break;

        case rcc.vitASuppCurrID :
            indMstID = rcc.vitASuppMstID;
            break;

        case rcc.introSolidSoftFoodsCurrID :
            indMstID = rcc.introSolidSoftFoodsMstID;
            break;

        case rcc.minDietDiversityCurrID :
            indMstID = rcc.minDietDiversityMstID;
            break;

        case rcc.minMealFrequencyCurrID :
            indMstID = rcc.minMealFrequencyMstID;
            break;

        case rcc.minAcceptableDietCurrID :
            indMstID = rcc.minAcceptableDietMstID;
            break;

        case rcc.underweightPrevChildrenCurrID :
            indMstID = rcc.underweightPrevChildrenMstID;
            break;

        case rcc.stuntingPrevChildrenCurrID :
            indMstID = rcc.stuntingPrevChildrenMstID;
            break;

        case rcc.wastingPrevChildrenCurrID :
            indMstID = rcc.wastingPrevChildrenMstID;
            break;

        case rcc.overweightPrevChildrenCurrID :
            indMstID = rcc.overweightPrevChildrenMstID;
            break;

        case rcc.availITNsCurrID :
            indMstID = rcc.availITNsMstID;
            break;

        case rcc.ITN_HH_CovCurrID :
            indMstID = rcc.ITN_HH_CovMstID;
            break;

        case rcc.IRS_CurrID :
            indMstID = rcc.IRS_MstID;
            break;

        case rcc.impDrinkWaterSrcCurrID :
            indMstID = rcc.impDrinkWaterSrcMstID;
            break;

        case rcc.impDrinkWaterSrcHH_CovCurrID :
            indMstID = rcc.impDrinkWaterSrcHH_CovMstID;
            break;

        case rcc.impSanitFacilCurrID :
            indMstID = rcc.impSanitFacilMstID;
            break;

        case rcc.impSaniFacil_HH_CovCurrID :
            indMstID = rcc.impSaniFacil_HH_CovMstID;
            break;

        case rcc.safeDisposalChildStoolsCurrID :
            indMstID = rcc.safeDisposalChildStoolsMstID;
            break;

        case rcc.wealthIdxQuintileCurrID :
            indMstID = rcc.wealthIdxQuintileMstID;
            break;

        case rcc.birthRegistrationCurrID :
            indMstID = rcc.birthRegistrationMstID;
            break;

        case rcc.earlyFirstMarriageUnionCurrID :
            indMstID = rcc.earlyFirstMarriageUnionMstID;
            break;

        case rcc.youngW_MarriedUnionCurrID :
            indMstID = rcc.youngW_MarriedUnionMstID;
            break;

        case rcc.earlyChildbearingCurrID :
            indMstID = rcc.earlyChildbearingMstID;
            break;

        case rcc.prevFGM_W_CurrID :
            indMstID = rcc.prevFGM_W_MstID;
            break;

        case rcc.prevFGM_GirlsCurrID :
            indMstID = rcc.prevFGM_GirlsMstID;
            break;

        case rcc.multiSexPartnersCurrID :
            indMstID = rcc.multiSexPartnersMstID;
            break;

        case rcc.condomUseLastSexMultiSexPartnersCurrID :
            indMstID = rcc.condomUseLastSexMultiSexPartnersMstID;
            break;

        case rcc.sexNonRegPartnersCurrID :
            indMstID = rcc.sexNonRegPartnersMstID;
            break;

        case rcc.condomUseNonRegPartnersCurrID :
            indMstID = rcc.condomUseNonRegPartnersMstID;
            break;

        case rcc.neverMarriedChildrenNotSexActiveCurrID :
            indMstID = rcc.neverMarriedChildrenNotSexActiveMstID;
            break;

        case rcc.sexBefore15YrsCurrID :
            indMstID = rcc.sexBefore15YrsMstID;
            break;

        case rcc.sexActiveChildrenPastYearCurrID :
            indMstID = rcc.sexActiveChildrenPastYearMstID;
            break;

        case rcc.HIV_TestLast12MoResultsKnownCurrID :
            indMstID = rcc.HIV_TestLast12MoResultsKnownMstID;
            break;

        case rcc.employmentLast7DaysCurrID :
            indMstID = rcc.employmentLast7DaysMstID;
            break;

        case rcc.employmentLast12MoCurrID :
            indMstID = rcc.employmentLast12MoMstID;
            break;

        case rcc.cashEarningsCurrID :
            indMstID = rcc.cashEarningsMstID;
            break;

        case rcc.bankAccountsCurrID :
            indMstID = rcc.bankAccountsMstID;
            break;

        case rcc.ownershipMobilePhonesCurrID :
            indMstID = rcc.ownershipMobilePhonesMstID;
            break;

        case rcc.mobilePhoneFinancTransactionsCurrID :
            indMstID = rcc.mobilePhoneFinancTransactionsMstID;
            break;

        case rcc.ctrlOverOwnIncomeCurrID :
            indMstID = rcc.ctrlOverOwnIncomeMstID;
            break;

        case rcc.ctrlOverPartnerEarningsCurrID :
            indMstID = rcc.ctrlOverPartnerEarningsMstID;
            break;

        case rcc.decisMakingOwnHlthCareCurrID :
            indMstID = rcc.decisMakingOwnHlthCareMstID;
            break;

        case rcc.leavHouseWCurrID :
            indMstID = rcc.leavHouseWMstID;
            break;

        default :
            indMstID = 0;
            break;

    }

    return indMstID;

}

export function getDefIndCurrID(indMstID) {

    let indCurrID;

    switch (indMstID) {

        case rcc.demandFamPlanSatMstID :
            indCurrID = rcc.demandFamPlanSatCurrID;
            break;

        case rcc.CPR_MstID :
            indCurrID = rcc.CPR_CurrID;
            break;

        case rcc.usingContraceptMstID :
            indCurrID = rcc.usingContraceptCurrID;
            break;

        case rcc.famPlanDiscMstID :
            indCurrID = rcc.famPlanDiscCurrID;
            break;

        case rcc.ANC_MstID :
            indCurrID = rcc.ANC_CurrID;
            break;

        case rcc.contentANC_MstID :
            indCurrID = rcc.contentANC_CurrID;
            break;

        case rcc.accompANC_VisitMstID :
            indCurrID = rcc.accompANC_VisitCurrID;
            break;

        case rcc.partnerANC_ConsultMstID :
            indCurrID = rcc.partnerANC_ConsultCurrID;
            break;

        case rcc.HIV_TestANCMstID :
            indCurrID = rcc.HIV_TestANCCurrID;
            break;

        case rcc.HIV_CounsANCMstID :
            indCurrID = rcc.HIV_CounsANCCurrID;
            break;

        case rcc.ITN_CovPregWMstID :
            indCurrID = rcc.ITN_CovPregWCurrID;
            break;

        case rcc.IPTpMstID :
            indCurrID = rcc.IPTpCurrID;
            break;

        case rcc.ironAcidFolicSuppPregWMstID :
            indCurrID = rcc.ironAcidFolicSuppPregWCurrID;
            break;

        case rcc.neonatalTetanusProtectPregWMstID :
            indCurrID = rcc.neonatalTetanusProtectPregWCurrID;
            break;

        case rcc.SBA_MstID :
            indCurrID = rcc.SBA_CurrID;
            break;

        case rcc.institutionalDelivMstID :
            indCurrID = rcc.institutionalDelivCurrID;
            break;

        case rcc.partnerLabourDeliveryMstID :
            indCurrID = rcc.partnerLabourDeliveryCurrID;
            break;

        case rcc.C_SectionMstID :
            indCurrID = rcc.C_SectionCurrID;
            break;

        case rcc.postnatalVisitMotherMstID :
            indCurrID = rcc.postnatalVisitMotherCurrID;
            break;

        case rcc.postnatalVisitNewbornMstID :
            indCurrID = rcc.postnatalVisitNewbornCurrID;
            break;

        case rcc.thermalCordCareMstID :
            indCurrID = rcc.thermalCordCareCurrID;
            break;

        case rcc.skinToSkinCareMstID :
            indCurrID = rcc.skinToSkinCareCurrID;
            break;

        case rcc.BCG_MstID :
            indCurrID = rcc.BCG_CurrID;
            break;

        case rcc.measlesImmunMstID :
            indCurrID = rcc.measlesImmunCurrID;
            break;

        case rcc.pentaDPT3ImmunMstID :
            indCurrID = rcc.pentaDPT3ImmunCurrID;
            break;

        case rcc.pneumoImmunMstID :
            indCurrID = rcc.pneumoImmunCurrID;
            break;

        case rcc.rotavirusImmunMstID :
            indCurrID = rcc.rotavirusImmunCurrID;
            break;

        case rcc.ITN_ChildrenU5MstID :
            indCurrID = rcc.ITN_ChildrenU5CurrID;
            break;

        case rcc.episodeFeverMstID :
            indCurrID = rcc.episodeFeverCurrID;
            break;

        case rcc.episodeDiarMstID :
            indCurrID = rcc.episodeDiarCurrID;
            break;

        case rcc.episodeSuspectPneumMstID :
            indCurrID = rcc.episodeSuspectPneumCurrID;
            break;

        case rcc.careSeekFeverMstID :
            indCurrID = rcc.careSeekFeverCurrID;
            break;

        case rcc.malariaFirstLineTreatmentMstID :
            indCurrID = rcc.malariaFirstLineTreatmentCurrID;
            break;

        case rcc.careSeekDiarMstID :
            indCurrID = rcc.careSeekDiarCurrID;
            break;

        case rcc.careSeekSuspectPneumMstID :
            indCurrID = rcc.careSeekSuspectPneumCurrID;
            break;

        case rcc.ORS_TreatDiarMstID :
            indCurrID = rcc.ORS_TreatDiarCurrID;
            break;

        case rcc.zincTreatDiarMstID :
            indCurrID = rcc.zincTreatDiarCurrID;
            break;

        case rcc.ORS_ZincTreatDiarMstID :
            indCurrID = rcc.ORS_ZincTreatDiarCurrID;
            break;

        case rcc.antimalarialTreatMstID :
            indCurrID = rcc.antimalarialTreatCurrID;
            break;

        case rcc.childEverBreastfedMstID :
            indCurrID = rcc.childEverBreastfedCurrID;
            break;

        case rcc.exclBF_LT6MoMstID :
            indCurrID = rcc.exclBF_LT6MoCurrID;
            break;

        case rcc.earlyInitBFMstID :
            indCurrID = rcc.earlyInitBFCurrID;
            break;

        case rcc.contBF_At1YrMstID :
            indCurrID = rcc.contBF_At1YrCurrID;
            break;

        case rcc.contBF_At2YrMstID :
            indCurrID = rcc.contBF_At2YrCurrID;
            break;

        case rcc.apprFeedPractMstID :
            indCurrID = rcc.apprFeedPractCurrID;
            break;

        case rcc.vitASuppMstID :
            indCurrID = rcc.vitASuppCurrID;
            break;

        case rcc.introSolidSoftFoodsMstID :
            indCurrID = rcc.introSolidSoftFoodsCurrID;
            break;

        case rcc.minDietDiversityMstID :
            indCurrID = rcc.minDietDiversityCurrID;
            break;

        case rcc.minMealFrequencyMstID :
            indCurrID = rcc.minMealFrequencyCurrID;
            break;

        case rcc.minAcceptableDietMstID :
            indCurrID = rcc.minAcceptableDietCurrID;
            break;

        case rcc.underweightPrevChildrenMstID :
            indCurrID = rcc.underweightPrevChildrenCurrID;
            break;

        case rcc.stuntingPrevChildrenMstID :
            indCurrID = rcc.stuntingPrevChildrenCurrID;
            break;

        case rcc.wastingPrevChildrenMstID :
            indCurrID = rcc.wastingPrevChildrenCurrID;
            break;

        case rcc.overweightPrevChildrenMstID :
            indCurrID = rcc.overweightPrevChildrenCurrID;
            break;

        case rcc.availITNsMstID :
            indCurrID = rcc.availITNsCurrID;
            break;

        case rcc.ITN_HH_CovMstID :
            indCurrID = rcc.ITN_HH_CovCurrID;
            break;

        case rcc.IRS_MstID :
            indCurrID = rcc.IRS_CurrID;
            break;

        case rcc.impDrinkWaterSrcMstID :
            indCurrID = rcc.impDrinkWaterSrcCurrID;
            break;

        case rcc.impDrinkWaterSrcHH_CovMstID :
            indCurrID = rcc.impDrinkWaterSrcHH_CovCurrID;
            break;

        case rcc.impSanitFacilMstID :
            indCurrID = rcc.impSanitFacilCurrID;
            break;

        case rcc.impSaniFacil_HH_CovMstID :
            indCurrID = rcc.impSaniFacil_HH_CovCurrID;
            break;

        case rcc.safeDisposalChildStoolsMstID :
            indCurrID = rcc.safeDisposalChildStoolsCurrID;
            break;

        case rcc.wealthIdxQuintileMstID :
            indCurrID = rcc.wealthIdxQuintileCurrID;
            break;

        case rcc.birthRegistrationMstID :
            indCurrID = rcc.birthRegistrationCurrID;
            break;

        case rcc.earlyFirstMarriageUnionMstID :
            indCurrID = rcc.earlyFirstMarriageUnionCurrID;
            break;

        case rcc.youngW_MarriedUnionMstID :
            indCurrID = rcc.youngW_MarriedUnionCurrID;
            break;

        case rcc.earlyChildbearingMstID :
            indCurrID = rcc.earlyChildbearingCurrID;
            break;

        case rcc.prevFGM_W_MstID :
            indCurrID = rcc.prevFGM_W_CurrID;
            break;

        case rcc.prevFGM_GirlsMstID :
            indCurrID = rcc.prevFGM_GirlsCurrID;
            break;

        case rcc.multiSexPartnersMstID :
            indCurrID = rcc.multiSexPartnersCurrID;
            break;

        case rcc.condomUseLastSexMultiSexPartnersMstID :
            indCurrID = rcc.condomUseLastSexMultiSexPartnersCurrID;
            break;

        case rcc.sexNonRegPartnersMstID :
            indCurrID = rcc.sexNonRegPartnersCurrID;
            break;

        case rcc.condomUseNonRegPartnersMstID :
            indCurrID = rcc.condomUseNonRegPartnersCurrID;
            break;

        case rcc.neverMarriedChildrenNotSexActiveMstID :
            indCurrID = rcc.neverMarriedChildrenNotSexActiveCurrID;
            break;

        case rcc.sexBefore15YrsMstID :
            indCurrID = rcc.sexBefore15YrsCurrID;
            break;

        case rcc.sexActiveChildrenPastYearMstID :
            indCurrID = rcc.sexActiveChildrenPastYearCurrID;
            break;

        case rcc.HIV_TestLast12MoResultsKnownMstID :
            indCurrID = rcc.HIV_TestLast12MoResultsKnownCurrID;
            break;

        case rcc.employmentLast7DaysMstID :
            indCurrID = rcc.employmentLast7DaysCurrID;
            break;

        case rcc.employmentLast12MoMstID :
            indCurrID = rcc.employmentLast12MoCurrID;
            break;

        case rcc.cashEarningsMstID :
            indCurrID = rcc.cashEarningsCurrID;
            break;

        case rcc.bankAccountsMstID :
            indCurrID = rcc.bankAccountsCurrID;
            break;

        case rcc.ownershipMobilePhonesMstID :
            indCurrID = rcc.ownershipMobilePhonesCurrID;
            break;

        case rcc.mobilePhoneFinancTransactionsMstID :
            indCurrID = rcc.mobilePhoneFinancTransactionsCurrID;
            break;

        case rcc.ctrlOverOwnIncomeMstID :
            indCurrID = rcc.ctrlOverOwnIncomeCurrID;
            break;

        case rcc.ctrlOverPartnerEarningsMstID :
            indCurrID = rcc.ctrlOverPartnerEarningsCurrID;
            break;

        case rcc.decisMakingOwnHlthCareMstID :
            indCurrID = rcc.decisMakingOwnHlthCareCurrID;
            break;

        case rcc.leavHouseWMstID :
            indCurrID = rcc.leavHouseWCurrID;
            break;

        default :
            indCurrID = 0;
            break;
    }

    return indCurrID;

}

export function getDefIndAgeLowerBoundStart(indCurrID) {

    let lowerBoundStartStr;

    const c10t49Str = "10";
    const cNAStr = RS(SC.GB_stNA);
    const c15t49Str = "15";
    const c12t15Str = "12";
    const c10t15Str = "10";
    const c12to35Str = "12";

    switch (indCurrID) {

        case rcc.demandFamPlanSatCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.CPR_CurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.usingContraceptCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.famPlanDiscCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.ANC_CurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.contentANC_CurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.accompANC_VisitCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.partnerANC_ConsultCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.HIV_TestANCCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.HIV_CounsANCCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.ITN_CovPregWCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.IPTpCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.ironAcidFolicSuppPregWCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.neonatalTetanusProtectPregWCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.SBA_CurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.institutionalDelivCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.partnerLabourDeliveryCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.C_SectionCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.postnatalVisitMotherCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.postnatalVisitNewbornCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.thermalCordCareCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.skinToSkinCareCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.BCG_CurrID :
            lowerBoundStartStr = c12to35Str;
            break;

        case rcc.measlesImmunCurrID :
            lowerBoundStartStr = c12to35Str;
            break;

        case rcc.pentaDPT3ImmunCurrID :
            lowerBoundStartStr = c12to35Str;
            break;

        case rcc.pneumoImmunCurrID :
            lowerBoundStartStr = c12to35Str;
            break;

        case rcc.rotavirusImmunCurrID :
            lowerBoundStartStr = c12to35Str;
            break;

        case rcc.ITN_ChildrenU5CurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.episodeFeverCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.episodeDiarCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.episodeSuspectPneumCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.careSeekFeverCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.malariaFirstLineTreatmentCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.careSeekDiarCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.careSeekSuspectPneumCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.ORS_TreatDiarCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.zincTreatDiarCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.ORS_ZincTreatDiarCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.antimalarialTreatCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.childEverBreastfedCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.exclBF_LT6MoCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.earlyInitBFCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.contBF_At1YrCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.contBF_At2YrCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.apprFeedPractCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.vitASuppCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.introSolidSoftFoodsCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.minDietDiversityCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.minMealFrequencyCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.minAcceptableDietCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.underweightPrevChildrenCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.stuntingPrevChildrenCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.wastingPrevChildrenCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.overweightPrevChildrenCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.availITNsCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.ITN_HH_CovCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.IRS_CurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.impDrinkWaterSrcCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.impDrinkWaterSrcHH_CovCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.impSanitFacilCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.impSaniFacil_HH_CovCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.safeDisposalChildStoolsCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.wealthIdxQuintileCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.birthRegistrationCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.earlyFirstMarriageUnionCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.youngW_MarriedUnionCurrID :
            lowerBoundStartStr = c10t15Str;
            break;

        case rcc.earlyChildbearingCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.prevFGM_W_CurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.prevFGM_GirlsCurrID :
            lowerBoundStartStr = c15t49Str;
            break;

        case rcc.multiSexPartnersCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.condomUseLastSexMultiSexPartnersCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.sexNonRegPartnersCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.condomUseNonRegPartnersCurrID :
            lowerBoundStartStr = c10t49Str;
            break;

        case rcc.neverMarriedChildrenNotSexActiveCurrID :
            lowerBoundStartStr = c12t15Str;
            break;

        case rcc.sexBefore15YrsCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.sexActiveChildrenPastYearCurrID :
            lowerBoundStartStr = c12t15Str;
            break;

        case rcc.HIV_TestLast12MoResultsKnownCurrID :
            lowerBoundStartStr = c15t49Str;
            break;

        case rcc.employmentLast7DaysCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.employmentLast12MoCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.cashEarningsCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.bankAccountsCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.ownershipMobilePhonesCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.mobilePhoneFinancTransactionsCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.ctrlOverOwnIncomeCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.ctrlOverPartnerEarningsCurrID :
            lowerBoundStartStr = c15t49Str;
            break;

        case rcc.decisMakingOwnHlthCareCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        case rcc.leavHouseWCurrID :
            lowerBoundStartStr = cNAStr;
            break;

        default :
            lowerBoundStartStr = "";
            break;

    }

    return lowerBoundStartStr;
}

export function getDefIndAgeLowerBoundEnd(indCurrID) {

    let lowerBoundEndStr;

    const c10t49Str = "49";
    const cNAStr = RS(SC.GB_stNA);
    const c15t49Str = "49";
    const c12t15Str = "15";
    const c10t15Str = "15";
    const c12to35Str = "35";

    switch (indCurrID) {

        case rcc.demandFamPlanSatCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.CPR_CurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.usingContraceptCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.famPlanDiscCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.ANC_CurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.contentANC_CurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.accompANC_VisitCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.partnerANC_ConsultCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.HIV_TestANCCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.HIV_CounsANCCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.ITN_CovPregWCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.IPTpCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.ironAcidFolicSuppPregWCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.neonatalTetanusProtectPregWCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.SBA_CurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.institutionalDelivCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.partnerLabourDeliveryCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.C_SectionCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.postnatalVisitMotherCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.postnatalVisitNewbornCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.thermalCordCareCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.skinToSkinCareCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.BCG_CurrID :
            lowerBoundEndStr = c12to35Str;
            break;

        case rcc.measlesImmunCurrID :
            lowerBoundEndStr = c12to35Str;
            break;

        case rcc.pentaDPT3ImmunCurrID :
            lowerBoundEndStr = c12to35Str;
            break;

        case rcc.pneumoImmunCurrID :
            lowerBoundEndStr = c12to35Str;
            break;

        case rcc.rotavirusImmunCurrID :
            lowerBoundEndStr = c12to35Str;
            break;

        case rcc.ITN_ChildrenU5CurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.episodeFeverCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.episodeDiarCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.episodeSuspectPneumCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.careSeekFeverCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.malariaFirstLineTreatmentCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.careSeekDiarCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.careSeekSuspectPneumCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.ORS_TreatDiarCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.zincTreatDiarCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.ORS_ZincTreatDiarCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.antimalarialTreatCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.childEverBreastfedCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.exclBF_LT6MoCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.earlyInitBFCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.contBF_At1YrCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.contBF_At2YrCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.apprFeedPractCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.vitASuppCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.introSolidSoftFoodsCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.minDietDiversityCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.minMealFrequencyCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.minAcceptableDietCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.underweightPrevChildrenCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.stuntingPrevChildrenCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.wastingPrevChildrenCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.overweightPrevChildrenCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.availITNsCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.ITN_HH_CovCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.IRS_CurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.impDrinkWaterSrcCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.impDrinkWaterSrcHH_CovCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.impSanitFacilCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.impSaniFacil_HH_CovCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.safeDisposalChildStoolsCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.wealthIdxQuintileCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.birthRegistrationCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.earlyFirstMarriageUnionCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.youngW_MarriedUnionCurrID :
            lowerBoundEndStr = c10t15Str;
            break;

        case rcc.earlyChildbearingCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.prevFGM_W_CurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.prevFGM_GirlsCurrID :
            lowerBoundEndStr = c15t49Str;
            break;

        case rcc.multiSexPartnersCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.condomUseLastSexMultiSexPartnersCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.sexNonRegPartnersCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.condomUseNonRegPartnersCurrID :
            lowerBoundEndStr = c10t49Str;
            break;

        case rcc.neverMarriedChildrenNotSexActiveCurrID :
            lowerBoundEndStr = c12t15Str;
            break;

        case rcc.sexBefore15YrsCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.sexActiveChildrenPastYearCurrID :
            lowerBoundEndStr = c12t15Str;
            break;

        case rcc.HIV_TestLast12MoResultsKnownCurrID :
            lowerBoundEndStr = c15t49Str;
            break;

        case rcc.employmentLast7DaysCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.employmentLast12MoCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.cashEarningsCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.bankAccountsCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.ownershipMobilePhonesCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.mobilePhoneFinancTransactionsCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.ctrlOverOwnIncomeCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.ctrlOverPartnerEarningsCurrID :
            lowerBoundEndStr = c15t49Str;
            break;

        case rcc.decisMakingOwnHlthCareCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        case rcc.leavHouseWCurrID :
            lowerBoundEndStr = cNAStr;
            break;

        default :
            lowerBoundEndStr = "";
            break;

    }

    return lowerBoundEndStr;
    
}

export function getDefIndAgeUpperBoundStart(indCurrID) {

    let upperBoundStartStr;

    const c10t49Str = "10";
    const cNAStr = RS(SC.GB_stNA);
    const c15t49Str = "15";
    const c19t24Str = "19";
    const c12to35Str = "12";

    switch (indCurrID) {

        case rcc.demandFamPlanSatCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.CPR_CurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.usingContraceptCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.famPlanDiscCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.ANC_CurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.contentANC_CurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.accompANC_VisitCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.partnerANC_ConsultCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.HIV_TestANCCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.HIV_CounsANCCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.ITN_CovPregWCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.IPTpCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.ironAcidFolicSuppPregWCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.neonatalTetanusProtectPregWCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.SBA_CurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.institutionalDelivCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.partnerLabourDeliveryCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.C_SectionCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.postnatalVisitMotherCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.postnatalVisitNewbornCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.thermalCordCareCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.skinToSkinCareCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.BCG_CurrID :
            upperBoundStartStr = c12to35Str;
            break;

        case rcc.measlesImmunCurrID :
            upperBoundStartStr = c12to35Str;
            break;

        case rcc.pentaDPT3ImmunCurrID :
            upperBoundStartStr = c12to35Str;
            break;

        case rcc.pneumoImmunCurrID :
            upperBoundStartStr = c12to35Str;
            break;

        case rcc.rotavirusImmunCurrID :
            upperBoundStartStr = c12to35Str;
            break;

        case rcc.ITN_ChildrenU5CurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.episodeFeverCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.episodeDiarCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.episodeSuspectPneumCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.careSeekFeverCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.malariaFirstLineTreatmentCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.careSeekDiarCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.careSeekSuspectPneumCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.ORS_TreatDiarCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.zincTreatDiarCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.ORS_ZincTreatDiarCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.antimalarialTreatCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.childEverBreastfedCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.exclBF_LT6MoCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.earlyInitBFCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.contBF_At1YrCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.contBF_At2YrCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.apprFeedPractCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.vitASuppCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.introSolidSoftFoodsCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.minDietDiversityCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.minMealFrequencyCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.minAcceptableDietCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.underweightPrevChildrenCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.stuntingPrevChildrenCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.wastingPrevChildrenCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.overweightPrevChildrenCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.availITNsCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.ITN_HH_CovCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.IRS_CurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.impDrinkWaterSrcCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.impDrinkWaterSrcHH_CovCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.impSanitFacilCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.impSaniFacil_HH_CovCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.safeDisposalChildStoolsCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.wealthIdxQuintileCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.birthRegistrationCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.earlyFirstMarriageUnionCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.youngW_MarriedUnionCurrID :
            upperBoundStartStr = c19t24Str;
            break;

        case rcc.earlyChildbearingCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.prevFGM_W_CurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.prevFGM_GirlsCurrID :
            upperBoundStartStr = c15t49Str;
            break;

        case rcc.multiSexPartnersCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.condomUseLastSexMultiSexPartnersCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.sexNonRegPartnersCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.condomUseNonRegPartnersCurrID :
            upperBoundStartStr = c10t49Str;
            break;

        case rcc.neverMarriedChildrenNotSexActiveCurrID :
            upperBoundStartStr = c19t24Str;
            break;

        case rcc.sexBefore15YrsCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.sexActiveChildrenPastYearCurrID :
            upperBoundStartStr = c19t24Str;
            break;

        case rcc.HIV_TestLast12MoResultsKnownCurrID :
            upperBoundStartStr = c15t49Str;
            break;

        case rcc.employmentLast7DaysCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.employmentLast12MoCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.cashEarningsCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.bankAccountsCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.ownershipMobilePhonesCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.mobilePhoneFinancTransactionsCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.ctrlOverOwnIncomeCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.ctrlOverPartnerEarningsCurrID :
            upperBoundStartStr = c15t49Str;
            break;

        case rcc.decisMakingOwnHlthCareCurrID :
            upperBoundStartStr = cNAStr;
            break;

        case rcc.leavHouseWCurrID :
            upperBoundStartStr = cNAStr;
            break;

        default :
            upperBoundStartStr = "";
            break;

    }

    return upperBoundStartStr;
}

export function getDefIndAgeUpperBoundEnd(indCurrID) {

    let upperBoundEndStr;

    const c10t49Str = "49";
    const cNAStr = RS(SC.GB_stNA);
    const c15t49Str = "49";
    const c19t24Str = "24";
    const c12to35Str = "35";

    switch (indCurrID) {

        case rcc.demandFamPlanSatCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.CPR_CurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.usingContraceptCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.famPlanDiscCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.ANC_CurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.contentANC_CurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.accompANC_VisitCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.partnerANC_ConsultCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.HIV_TestANCCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.HIV_CounsANCCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.ITN_CovPregWCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.IPTpCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.ironAcidFolicSuppPregWCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.neonatalTetanusProtectPregWCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.SBA_CurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.institutionalDelivCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.partnerLabourDeliveryCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.C_SectionCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.postnatalVisitMotherCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.postnatalVisitNewbornCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.thermalCordCareCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.skinToSkinCareCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.BCG_CurrID :
            upperBoundEndStr = c12to35Str;
            break;

        case rcc.measlesImmunCurrID :
            upperBoundEndStr = c12to35Str;
            break;

        case rcc.pentaDPT3ImmunCurrID :
            upperBoundEndStr = c12to35Str;
            break;

        case rcc.pneumoImmunCurrID :
            upperBoundEndStr = c12to35Str;
            break;

        case rcc.rotavirusImmunCurrID :
            upperBoundEndStr = c12to35Str;
            break;

        case rcc.ITN_ChildrenU5CurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.episodeFeverCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.episodeDiarCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.episodeSuspectPneumCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.careSeekFeverCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.malariaFirstLineTreatmentCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.careSeekDiarCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.careSeekSuspectPneumCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.ORS_TreatDiarCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.zincTreatDiarCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.ORS_ZincTreatDiarCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.antimalarialTreatCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.childEverBreastfedCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.exclBF_LT6MoCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.earlyInitBFCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.contBF_At1YrCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.contBF_At2YrCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.apprFeedPractCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.vitASuppCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.introSolidSoftFoodsCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.minDietDiversityCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.minMealFrequencyCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.minAcceptableDietCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.underweightPrevChildrenCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.stuntingPrevChildrenCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.wastingPrevChildrenCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.overweightPrevChildrenCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.availITNsCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.ITN_HH_CovCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.IRS_CurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.impDrinkWaterSrcCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.impDrinkWaterSrcHH_CovCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.impSanitFacilCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.impSaniFacil_HH_CovCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.safeDisposalChildStoolsCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.wealthIdxQuintileCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.birthRegistrationCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.earlyFirstMarriageUnionCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.youngW_MarriedUnionCurrID :
            upperBoundEndStr = c19t24Str;
            break;

        case rcc.earlyChildbearingCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.prevFGM_W_CurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.prevFGM_GirlsCurrID :
            upperBoundEndStr = c15t49Str;
            break;

        case rcc.multiSexPartnersCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.condomUseLastSexMultiSexPartnersCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.sexNonRegPartnersCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.condomUseNonRegPartnersCurrID :
            upperBoundEndStr = c10t49Str;
            break;

        case rcc.neverMarriedChildrenNotSexActiveCurrID :
            upperBoundEndStr = c19t24Str;
            break;

        case rcc.sexBefore15YrsCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.sexActiveChildrenPastYearCurrID :
            upperBoundEndStr = c19t24Str;
            break;

        case rcc.HIV_TestLast12MoResultsKnownCurrID :
            upperBoundEndStr = c15t49Str;
            break;

        case rcc.employmentLast7DaysCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.employmentLast12MoCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.cashEarningsCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.bankAccountsCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.ownershipMobilePhonesCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.mobilePhoneFinancTransactionsCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.ctrlOverOwnIncomeCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.ctrlOverPartnerEarningsCurrID :
            upperBoundEndStr = c15t49Str;
            break;

        case rcc.decisMakingOwnHlthCareCurrID :
            upperBoundEndStr = cNAStr;
            break;

        case rcc.leavHouseWCurrID :
            upperBoundEndStr = cNAStr;
            break;

        default :
            upperBoundEndStr = "";
            break;

    }

    return upperBoundEndStr;

}

export function getDefIndRefPeriod(indCurrID) {

    let refPeriod;

    const c235YrsArray = [2, 3, 5];
    const cMonthsArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const cNA = RS(SC.GB_stNA);

    switch (indCurrID) {

        case rcc.demandFamPlanSatCurrID :
            refPeriod = cNA;
            break;

        case rcc.CPR_CurrID :
            refPeriod = cNA;
            break;

        case rcc.usingContraceptCurrID :
            refPeriod = cNA;
            break;

        case rcc.famPlanDiscCurrID :
            refPeriod = cNA;
            break;

        case rcc.ANC_CurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.contentANC_CurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.accompANC_VisitCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.partnerANC_ConsultCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.HIV_TestANCCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.HIV_CounsANCCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.ITN_CovPregWCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.IPTpCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.ironAcidFolicSuppPregWCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.neonatalTetanusProtectPregWCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.SBA_CurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.institutionalDelivCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.partnerLabourDeliveryCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.C_SectionCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.postnatalVisitMotherCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.postnatalVisitNewbornCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.thermalCordCareCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.skinToSkinCareCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.BCG_CurrID :
            refPeriod = cNA;
            break;

        case rcc.measlesImmunCurrID :
            refPeriod = cNA;
            break;

        case rcc.pentaDPT3ImmunCurrID :
            refPeriod = cNA;
            break;

        case rcc.pneumoImmunCurrID :
            refPeriod = cNA;
            break;

        case rcc.rotavirusImmunCurrID :
            refPeriod = cNA;
            break;

        case rcc.ITN_ChildrenU5CurrID :
            refPeriod = cNA;
            break;

        case rcc.episodeFeverCurrID :
            refPeriod = cNA;
            break;

        case rcc.episodeDiarCurrID :
            refPeriod = cNA;
            break;

        case rcc.episodeSuspectPneumCurrID :
            refPeriod = cNA;
            break;

        case rcc.careSeekFeverCurrID :
            refPeriod = cNA;
            break;

        case rcc.malariaFirstLineTreatmentCurrID :
            refPeriod = cNA;
            break;

        case rcc.careSeekDiarCurrID :
            refPeriod = cNA;
            break;

        case rcc.careSeekSuspectPneumCurrID :
            refPeriod = cNA;
            break;

        case rcc.ORS_TreatDiarCurrID :
            refPeriod = cNA;
            break;

        case rcc.zincTreatDiarCurrID :
            refPeriod = cNA;
            break;

        case rcc.ORS_ZincTreatDiarCurrID :
            refPeriod = cNA;
            break;

        case rcc.antimalarialTreatCurrID :
            refPeriod = cNA;
            break;

        case rcc.childEverBreastfedCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.exclBF_LT6MoCurrID :
            refPeriod = cNA;
            break;

        case rcc.earlyInitBFCurrID :
            refPeriod = c235YrsArray;
            break;

        case rcc.contBF_At1YrCurrID :
            refPeriod = cNA;
            break;

        case rcc.contBF_At2YrCurrID :
            refPeriod = cNA;
            break;

        case rcc.apprFeedPractCurrID :
            refPeriod = cNA;
            break;

        case rcc.vitASuppCurrID :
            refPeriod = cNA;
            break;

        case rcc.introSolidSoftFoodsCurrID :
            refPeriod = cNA;
            break;

        case rcc.minDietDiversityCurrID :
            refPeriod = cNA;
            break;

        case rcc.minMealFrequencyCurrID :
            refPeriod = cNA;
            break;

        case rcc.minAcceptableDietCurrID :
            refPeriod = cNA;
            break;

        case rcc.underweightPrevChildrenCurrID :
            refPeriod = cNA;
            break;

        case rcc.stuntingPrevChildrenCurrID :
            refPeriod = cNA;
            break;

        case rcc.wastingPrevChildrenCurrID :
            refPeriod = cNA;
            break;

        case rcc.overweightPrevChildrenCurrID :
            refPeriod = cNA;
            break;

        case rcc.availITNsCurrID :
            refPeriod = cNA;
            break;

        case rcc.ITN_HH_CovCurrID :
            refPeriod = cNA;
            break;

        case rcc.IRS_CurrID :
            refPeriod = cNA;
            break;

        case rcc.impDrinkWaterSrcCurrID :
            refPeriod = cNA;
            break;

        case rcc.impDrinkWaterSrcHH_CovCurrID :
            refPeriod = cNA;
            break;

        case rcc.impSanitFacilCurrID :
            refPeriod = cNA;
            break;

        case rcc.impSaniFacil_HH_CovCurrID :
            refPeriod = cNA;
            break;

        case rcc.safeDisposalChildStoolsCurrID :
            refPeriod = cNA;
            break;

        case rcc.wealthIdxQuintileCurrID :
            refPeriod = cNA;
            break;

        case rcc.birthRegistrationCurrID :
            refPeriod = cNA;
            break;

        case rcc.earlyFirstMarriageUnionCurrID :
            refPeriod = cNA;
            break;

        case rcc.youngW_MarriedUnionCurrID :
            refPeriod = cNA;
            break;

        case rcc.earlyChildbearingCurrID :
            refPeriod = cNA;
            break;

        case rcc.prevFGM_W_CurrID :
            refPeriod = cNA;
            break;

        case rcc.prevFGM_GirlsCurrID :
            refPeriod = cNA;
            break;

        case rcc.multiSexPartnersCurrID :
            refPeriod = cNA;
            break;

        case rcc.condomUseLastSexMultiSexPartnersCurrID :
            refPeriod = cNA;
            break;

        case rcc.sexNonRegPartnersCurrID :
            refPeriod = cNA;
            break;

        case rcc.condomUseNonRegPartnersCurrID :
            refPeriod = cNA;
            break;

        case rcc.neverMarriedChildrenNotSexActiveCurrID :
            refPeriod = cNA;
            break;

        case rcc.sexBefore15YrsCurrID :
            refPeriod = cNA;
            break;

        case rcc.sexActiveChildrenPastYearCurrID :
            refPeriod = cNA;
            break;

        case rcc.HIV_TestLast12MoResultsKnownCurrID :
            refPeriod = cMonthsArray;
            break;

        case rcc.employmentLast7DaysCurrID :
            refPeriod = cNA;
            break;

        case rcc.employmentLast12MoCurrID :
            refPeriod = cNA;
            break;

        case rcc.cashEarningsCurrID :
            refPeriod = cNA;
            break;

        case rcc.bankAccountsCurrID :
            refPeriod = cNA;
            break;

        case rcc.ownershipMobilePhonesCurrID :
            refPeriod = cNA;
            break;

        case rcc.mobilePhoneFinancTransactionsCurrID :
            refPeriod = cNA;
            break;

        case rcc.ctrlOverOwnIncomeCurrID :
            refPeriod = cNA;
            break;

        case rcc.ctrlOverPartnerEarningsCurrID :
            refPeriod = cNA;
            break;

        case rcc.decisMakingOwnHlthCareCurrID :
            refPeriod = cNA;
            break;

        case rcc.leavHouseWCurrID :
            refPeriod = cNA;
            break;

        default :
            refPeriod = "";
            break;

    }

    return refPeriod;
    
}

export function getGenderArray () {

    const genderArray = [
        getGenderPlural(gbc.sex.both, false),
        getGenderPlural(gbc.sex.female),
        getGenderPlural(gbc.sex.male),
    ];

    return genderArray;

}

export function getDefIndGender(indCurrID) {

    let value;

    const cNA = RS(SC.GB_stNA);
    const sexArray = getGenderArray();

    switch (indCurrID) {

        case rcc.demandFamPlanSatCurrID :
            value = cNA;
            break;

        case rcc.CPR_CurrID :
            value = cNA;
            break;

        case rcc.usingContraceptCurrID :
            value = cNA;
            break;

        case rcc.famPlanDiscCurrID :
            value = cNA;
            break;

        case rcc.ANC_CurrID :
            value = cNA;
            break;

        case rcc.contentANC_CurrID :
            value = cNA;
            break;

        case rcc.accompANC_VisitCurrID :
            value = cNA;
            break;

        case rcc.partnerANC_ConsultCurrID :
            value = cNA;
            break;

        case rcc.HIV_TestANCCurrID :
            value = cNA;
            break;

        case rcc.HIV_CounsANCCurrID :
            value = cNA;
            break;

        case rcc.ITN_CovPregWCurrID :
            value = cNA;
            break;

        case rcc.IPTpCurrID :
            value = cNA;
            break;

        case rcc.ironAcidFolicSuppPregWCurrID :
            value = cNA;
            break;

        case rcc.neonatalTetanusProtectPregWCurrID :
            value = cNA;
            break;

        case rcc.SBA_CurrID :
            value = cNA;
            break;

        case rcc.institutionalDelivCurrID :
            value = cNA;
            break;

        case rcc.partnerLabourDeliveryCurrID :
            value = cNA;
            break;

        case rcc.C_SectionCurrID :
            value = cNA;
            break;

        case rcc.postnatalVisitMotherCurrID :
            value = cNA;
            break;

        case rcc.postnatalVisitNewbornCurrID :
            value = cNA;
            break;

        case rcc.thermalCordCareCurrID :
            value = cNA;
            break;

        case rcc.skinToSkinCareCurrID :
            value = cNA;
            break;

        case rcc.BCG_CurrID :
            value = cNA;
            break;

        case rcc.measlesImmunCurrID :
            value = cNA;
            break;

        case rcc.pentaDPT3ImmunCurrID :
            value = cNA;
            break;

        case rcc.pneumoImmunCurrID :
            value = cNA;
            break;

        case rcc.rotavirusImmunCurrID :
            value = cNA;
            break;

        case rcc.ITN_ChildrenU5CurrID :
            value = cNA;
            break;

        case rcc.episodeFeverCurrID :
            value = cNA;
            break;

        case rcc.episodeDiarCurrID :
            value = cNA;
            break;

        case rcc.episodeSuspectPneumCurrID :
            value = cNA;
            break;

        case rcc.careSeekFeverCurrID :
            value = cNA;
            break;

        case rcc.malariaFirstLineTreatmentCurrID :
            value = cNA;
            break;

        case rcc.careSeekDiarCurrID :
            value = cNA;
            break;

        case rcc.careSeekSuspectPneumCurrID :
            value = cNA;
            break;

        case rcc.ORS_TreatDiarCurrID :
            value = cNA;
            break;

        case rcc.zincTreatDiarCurrID :
            value = cNA;
            break;

        case rcc.ORS_ZincTreatDiarCurrID :
            value = cNA;
            break;

        case rcc.antimalarialTreatCurrID :
            value = cNA;
            break;

        case rcc.childEverBreastfedCurrID :
            value = cNA;
            break;

        case rcc.exclBF_LT6MoCurrID :
            value = cNA;
            break;

        case rcc.earlyInitBFCurrID :
            value = cNA;
            break;

        case rcc.contBF_At1YrCurrID :
            value = cNA;
            break;

        case rcc.contBF_At2YrCurrID :
            value = cNA;
            break;

        case rcc.apprFeedPractCurrID :
            value = cNA;
            break;

        case rcc.vitASuppCurrID :
            value = cNA;
            break;

        case rcc.introSolidSoftFoodsCurrID :
            value = cNA;
            break;

        case rcc.minDietDiversityCurrID :
            value = cNA;
            break;

        case rcc.minMealFrequencyCurrID :
            value = cNA;
            break;

        case rcc.minAcceptableDietCurrID :
            value = cNA;
            break;

        case rcc.underweightPrevChildrenCurrID :
            value = cNA;
            break;

        case rcc.stuntingPrevChildrenCurrID :
            value = cNA;
            break;

        case rcc.wastingPrevChildrenCurrID :
            value = cNA;
            break;

        case rcc.overweightPrevChildrenCurrID :
            value = cNA;
            break;

        case rcc.availITNsCurrID :
            value = cNA;
            break;

        case rcc.ITN_HH_CovCurrID :
            value = cNA;
            break;

        case rcc.IRS_CurrID :
            value = cNA;
            break;

        case rcc.impDrinkWaterSrcCurrID :
            value = cNA;
            break;

        case rcc.impDrinkWaterSrcHH_CovCurrID :
            value = cNA;
            break;

        case rcc.impSanitFacilCurrID :
            value = cNA;
            break;

        case rcc.impSaniFacil_HH_CovCurrID :
            value = cNA;
            break;

        case rcc.safeDisposalChildStoolsCurrID :
            value = cNA;
            break;

        case rcc.wealthIdxQuintileCurrID :
            value = cNA;
            break;

        case rcc.birthRegistrationCurrID :
            value = cNA;
            break;

        case rcc.earlyFirstMarriageUnionCurrID :
            value = cNA;
            break;

        case rcc.youngW_MarriedUnionCurrID :
            value = cNA;
            break;

        case rcc.earlyChildbearingCurrID :
            value = cNA;
            break;

        case rcc.prevFGM_W_CurrID :
            value = cNA;
            break;

        case rcc.prevFGM_GirlsCurrID :
            value = cNA;
            break;

        case rcc.multiSexPartnersCurrID :
            value = sexArray;
            break;

        case rcc.condomUseLastSexMultiSexPartnersCurrID :
            value = sexArray;
            break;

        case rcc.sexNonRegPartnersCurrID :
            value = sexArray;
            break;

        case rcc.condomUseNonRegPartnersCurrID :
            value = sexArray;
            break;

        case rcc.neverMarriedChildrenNotSexActiveCurrID :
            value = sexArray;
            break;

        case rcc.sexBefore15YrsCurrID :
            value = sexArray;
            break;

        case rcc.sexActiveChildrenPastYearCurrID :
            value = sexArray;
            break;

        case rcc.HIV_TestLast12MoResultsKnownCurrID :
            value = sexArray;
            break;

        case rcc.employmentLast7DaysCurrID :
            value = sexArray;
            break;

        case rcc.employmentLast12MoCurrID :
            value = sexArray;
            break;

        case rcc.cashEarningsCurrID :
            value = sexArray;
            break;

        case rcc.bankAccountsCurrID :
            value = sexArray;
            break;

        case rcc.ownershipMobilePhonesCurrID :
            value = sexArray;
            break;

        case rcc.mobilePhoneFinancTransactionsCurrID :
            value = sexArray;
            break;

        case rcc.ctrlOverOwnIncomeCurrID :
            value = sexArray;
            break;

        case rcc.ctrlOverPartnerEarningsCurrID :
            value = sexArray;
            break;

        case rcc.decisMakingOwnHlthCareCurrID :
            value = sexArray;
            break;

        case rcc.leavHouseWCurrID :
            value = cNA;
            break;

        default :
            value = "";
            break;

    }

    return value;

}

export function getDefIndPossibleTargPop1DIntArray(defIndCurrID) {

    let possibleTargPop1DIntArray = [];

    switch (defIndCurrID) {

        case rcc.demandFamPlanSatCurrID :
            possibleTargPop1DIntArray.push(rcc.womenInUnionOrSexActiveTargPopCurrID);
            break;

        case rcc.CPR_CurrID :
            possibleTargPop1DIntArray.push(rcc.womenInUnionOrSexActiveTargPopCurrID);
            break;

        case rcc.usingContraceptCurrID :
            possibleTargPop1DIntArray.push(rcc.womenInUnionOrSexActiveTargPopCurrID);
            break;

        case rcc.famPlanDiscCurrID :
            possibleTargPop1DIntArray.push(rcc.womenInUnionOrSexActiveTargPopCurrID);
            break;

        case rcc.ANC_CurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.contentANC_CurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.accompANC_VisitCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.partnerANC_ConsultCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.HIV_TestANCCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.HIV_CounsANCCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.ITN_CovPregWCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.IPTpCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.ironAcidFolicSuppPregWCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.neonatalTetanusProtectPregWCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.SBA_CurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.institutionalDelivCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.partnerLabourDeliveryCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.C_SectionCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.postnatalVisitMotherCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.postnatalVisitNewbornCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.thermalCordCareCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.skinToSkinCareCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.BCG_CurrID :
            possibleTargPop1DIntArray.push(rcc.infantsSurveyedTargPopCurrID);
            break;

        case rcc.measlesImmunCurrID :
            possibleTargPop1DIntArray.push(rcc.infantsSurveyedTargPopCurrID);
            break;

        case rcc.pentaDPT3ImmunCurrID :
            possibleTargPop1DIntArray.push(rcc.infantsSurveyedTargPopCurrID);
            break;

        case rcc.pneumoImmunCurrID :
            possibleTargPop1DIntArray.push(rcc.infantsSurveyedTargPopCurrID);
            break;

        case rcc.rotavirusImmunCurrID :
            possibleTargPop1DIntArray.push(rcc.infantsSurveyedTargPopCurrID);
            break;

        case rcc.ITN_ChildrenU5CurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5SleptHouseTargPopCurrID);
            break;

        case rcc.episodeFeverCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5TargPopCurrID);
            break;

        case rcc.episodeDiarCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5TargPopCurrID);
            break;

        case rcc.episodeSuspectPneumCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5TargPopCurrID);
            break;

        case rcc.careSeekFeverCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5Fever2WksTargPopCurrID);
            break;

        case rcc.malariaFirstLineTreatmentCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5Fever2WksDrugsTargPopCurrID);
            break;

        case rcc.careSeekDiarCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5Diar2WksTargPopCurrID);
            break;

        case rcc.careSeekSuspectPneumCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5Pneum2WksTargPopCurrID);
            break;

        case rcc.ORS_TreatDiarCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5Diar2WksTargPopCurrID);
            break;

        case rcc.zincTreatDiarCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5Diar2WksTargPopCurrID);
            break;

        case rcc.ORS_ZincTreatDiarCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5Diar2WksTargPopCurrID);
            break;

        case rcc.antimalarialTreatCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5Fever2WksTargPopCurrID);
            break;

        case rcc.childEverBreastfedCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.exclBF_LT6MoCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5TargPopCurrID);
            break;

        case rcc.earlyInitBFCurrID :
            possibleTargPop1DIntArray.push(rcc.womenWithLiveBirthTargPopCurrID);
            break;

        case rcc.contBF_At1YrCurrID :
            possibleTargPop1DIntArray.push(rcc.infants12t15MoSurveyedTargPopCurrID);
            break;

        case rcc.contBF_At2YrCurrID :
            possibleTargPop1DIntArray.push(rcc.infants20t23MoSurveyedTargPopCurrID);
            break;

        case rcc.apprFeedPractCurrID :
            possibleTargPop1DIntArray.push(rcc.infants6t23MoSurveyedTargPopCurrID);
            break;

        case rcc.vitASuppCurrID :
            possibleTargPop1DIntArray.push(rcc.infants6t59MoSurveyedTargPopCurrID);
            break;

        case rcc.introSolidSoftFoodsCurrID :
            possibleTargPop1DIntArray.push(rcc.infants6t8MoSurveyedTargPopCurrID);
            break;

        case rcc.minDietDiversityCurrID :
            possibleTargPop1DIntArray.push(rcc.infants6t59MoSurveyedTargPopCurrID);
            break;

        case rcc.minMealFrequencyCurrID :
            possibleTargPop1DIntArray.push(rcc.infants6t59MoSurveyedTargPopCurrID);
            break;

        case rcc.minAcceptableDietCurrID :
            possibleTargPop1DIntArray.push(rcc.infants6t59MoSurveyedTargPopCurrID);
            break;

        case rcc.underweightPrevChildrenCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5TargPopCurrID);
            break;

        case rcc.stuntingPrevChildrenCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5TargPopCurrID);
            break;

        case rcc.wastingPrevChildrenCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5TargPopCurrID);
            break;

        case rcc.overweightPrevChildrenCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5TargPopCurrID);
            break;

        case rcc.availITNsCurrID :
            possibleTargPop1DIntArray.push(rcc.HHInterviewedTargPopCurrID);
            break;

        case rcc.ITN_HH_CovCurrID :
            possibleTargPop1DIntArray.push(rcc.HHMembersSleptHouseTargPopCurrID);
            break;

        case rcc.IRS_CurrID :
            possibleTargPop1DIntArray.push(rcc.HHInterviewedTargPopCurrID);
            break;

        case rcc.impDrinkWaterSrcCurrID :
            possibleTargPop1DIntArray.push(rcc.HHInterviewedTargPopCurrID);
            break;

        case rcc.impDrinkWaterSrcHH_CovCurrID :
            possibleTargPop1DIntArray.push(rcc.membersInterviewedHHTargPopCurrID);
            break;

        case rcc.impSanitFacilCurrID :
            possibleTargPop1DIntArray.push(rcc.HHInterviewedTargPopCurrID);
            break;

        case rcc.impSaniFacil_HH_CovCurrID :
            possibleTargPop1DIntArray.push(rcc.membersInterviewedHHTargPopCurrID);
            break;

        case rcc.safeDisposalChildStoolsCurrID :
            possibleTargPop1DIntArray.push(rcc.caretakersDispChildrenStoolsTargPopCurrID);
            break;

        case rcc.wealthIdxQuintileCurrID :
            possibleTargPop1DIntArray.push(rcc.HHInterviewedTargPopCurrID);
            break;

        case rcc.birthRegistrationCurrID :
            possibleTargPop1DIntArray.push(rcc.childrenU5TargPopCurrID);
            break;

        case rcc.earlyFirstMarriageUnionCurrID :
            possibleTargPop1DIntArray.push(rcc.women20t24TargPopCurrID);
            break;

        case rcc.youngW_MarriedUnionCurrID :
            possibleTargPop1DIntArray.push(rcc.womenTargPopCurrID);
            break;

        case rcc.earlyChildbearingCurrID :
            possibleTargPop1DIntArray.push(rcc.women20t24TargPopCurrID);
            break;

        case rcc.prevFGM_W_CurrID :
            possibleTargPop1DIntArray.push(rcc.women15t49TargPopCurrID);
            break;

        case rcc.prevFGM_GirlsCurrID :
            possibleTargPop1DIntArray.push(rcc.daughters0t14TargPopCurrID);
            break;

        case rcc.multiSexPartnersCurrID :
            possibleTargPop1DIntArray.push(rcc.peopleTargPopCurrID);
            break;

        case rcc.condomUseLastSexMultiSexPartnersCurrID :
            possibleTargPop1DIntArray.push(rcc.peopleMultiSexPartnersTargPopCurrID);
            break;

        case rcc.sexNonRegPartnersCurrID :
            possibleTargPop1DIntArray.push(rcc.peopleHadSexTargPopCurrID);
            break;

        case rcc.condomUseNonRegPartnersCurrID :
            possibleTargPop1DIntArray.push(rcc.peopleHadSexNonMarCohabPartnerTargPopCurrID);
            break;

        case rcc.neverMarriedChildrenNotSexActiveCurrID :
            possibleTargPop1DIntArray.push(rcc.peopleNeverMarriedTargPopCurrID);
            break;

        case rcc.sexBefore15YrsCurrID :
            possibleTargPop1DIntArray.push(rcc.people15t24TargPopCurrID);
            break;

        case rcc.sexActiveChildrenPastYearCurrID :
            possibleTargPop1DIntArray.push(rcc.peopleTargPopCurrID);
            break;

        case rcc.HIV_TestLast12MoResultsKnownCurrID :
            possibleTargPop1DIntArray.push(rcc.peopleTestedHIVTargPopCurrID);
            break;

        case rcc.employmentLast7DaysCurrID :
            possibleTargPop1DIntArray.push(rcc.people15t49TargPopCurrID);
            break;

        case rcc.employmentLast12MoCurrID :
            possibleTargPop1DIntArray.push(rcc.people15t49TargPopCurrID);
            break;

        case rcc.cashEarningsCurrID :
            possibleTargPop1DIntArray.push(rcc.people15t49TargPopCurrID);
            break;

        case rcc.bankAccountsCurrID :
            possibleTargPop1DIntArray.push(rcc.people15t49TargPopCurrID);
            break;

        case rcc.ownershipMobilePhonesCurrID :
            possibleTargPop1DIntArray.push(rcc.people15t49TargPopCurrID);
            break;

        case rcc.mobilePhoneFinancTransactionsCurrID :
            possibleTargPop1DIntArray.push(rcc.people15t49TargPopCurrID);
            break;

        case rcc.ctrlOverOwnIncomeCurrID :
            possibleTargPop1DIntArray.push(rcc.people15t49TargPopCurrID);
            break;

        case rcc.ctrlOverPartnerEarningsCurrID :
            possibleTargPop1DIntArray.push(rcc.peopleMarCohabPartnerUnionTargPopCurrID);
            break;

        case rcc.decisMakingOwnHlthCareCurrID :
            possibleTargPop1DIntArray.push(rcc.people15t49TargPopCurrID);
            break;

        case rcc.leavHouseWCurrID :
            possibleTargPop1DIntArray.push(rcc.women15t49TargPopCurrID);
            break;

        default :
            possibleTargPop1DIntArray = [];
            break;
    }

    return possibleTargPop1DIntArray;

}

export function getDefTargPopCurrID(defIndCurrID) {

    let targPopCurrID;

    switch (defIndCurrID) {

        case rcc.demandFamPlanSatCurrID :
            targPopCurrID = rcc.womenInUnionOrSexActiveTargPopCurrID;
            break;

        case rcc.CPR_CurrID :
            targPopCurrID = rcc.womenInUnionOrSexActiveTargPopCurrID;
            break;

        case rcc.usingContraceptCurrID :
            targPopCurrID = rcc.womenInUnionOrSexActiveTargPopCurrID;
            break;

        case rcc.famPlanDiscCurrID :
            targPopCurrID = rcc.womenInUnionOrSexActiveTargPopCurrID;
            break;

        case rcc.ANC_CurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.contentANC_CurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.accompANC_VisitCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.partnerANC_ConsultCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.HIV_TestANCCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.HIV_CounsANCCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.ITN_CovPregWCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.IPTpCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.ironAcidFolicSuppPregWCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.neonatalTetanusProtectPregWCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.SBA_CurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.institutionalDelivCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.partnerLabourDeliveryCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.C_SectionCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.postnatalVisitMotherCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.postnatalVisitNewbornCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.thermalCordCareCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.skinToSkinCareCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.BCG_CurrID :
            targPopCurrID = rcc.infantsSurveyedTargPopCurrID;
            break;

        case rcc.measlesImmunCurrID :
            targPopCurrID = rcc.infantsSurveyedTargPopCurrID;
            break;

        case rcc.pentaDPT3ImmunCurrID :
            targPopCurrID = rcc.infantsSurveyedTargPopCurrID;
            break;

        case rcc.pneumoImmunCurrID :
            targPopCurrID = rcc.infantsSurveyedTargPopCurrID;
            break;

        case rcc.rotavirusImmunCurrID :
            targPopCurrID = rcc.infantsSurveyedTargPopCurrID;
            break;

        case rcc.ITN_ChildrenU5CurrID :
            targPopCurrID = rcc.childrenU5SleptHouseTargPopCurrID;
            break;

        case rcc.episodeFeverCurrID :
            targPopCurrID = rcc.childrenU5TargPopCurrID;
            break;

        case rcc.episodeDiarCurrID :
            targPopCurrID = rcc.childrenU5TargPopCurrID;
            break;

        case rcc.episodeSuspectPneumCurrID :
            targPopCurrID = rcc.childrenU5TargPopCurrID;
            break;

        case rcc.careSeekFeverCurrID :
            targPopCurrID = rcc.childrenU5Fever2WksTargPopCurrID;
            break;

        case rcc.malariaFirstLineTreatmentCurrID :
            targPopCurrID = rcc.childrenU5Fever2WksDrugsTargPopCurrID;
            break;

        case rcc.careSeekDiarCurrID :
            targPopCurrID = rcc.childrenU5Diar2WksTargPopCurrID;
            break;

        case rcc.careSeekSuspectPneumCurrID :
            targPopCurrID = rcc.childrenU5Pneum2WksTargPopCurrID;
            break;

        case rcc.ORS_TreatDiarCurrID :
            targPopCurrID = rcc.childrenU5Diar2WksTargPopCurrID;
            break;

        case rcc.zincTreatDiarCurrID :
            targPopCurrID = rcc.childrenU5Diar2WksTargPopCurrID;
            break;

        case rcc.ORS_ZincTreatDiarCurrID :
            targPopCurrID = rcc.childrenU5Diar2WksTargPopCurrID;
            break;

        case rcc.antimalarialTreatCurrID :
            targPopCurrID = rcc.childrenU5Fever2WksTargPopCurrID;
            break;

        case rcc.childEverBreastfedCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.exclBF_LT6MoCurrID :
            targPopCurrID = rcc.childrenU5TargPopCurrID;
            break;

        case rcc.earlyInitBFCurrID :
            targPopCurrID = rcc.womenWithLiveBirthTargPopCurrID;
            break;

        case rcc.contBF_At1YrCurrID :
            targPopCurrID = rcc.infants12t15MoSurveyedTargPopCurrID;
            break;

        case rcc.contBF_At2YrCurrID :
            targPopCurrID = rcc.infants20t23MoSurveyedTargPopCurrID;
            break;

        case rcc.apprFeedPractCurrID :
            targPopCurrID = rcc.infants6t23MoSurveyedTargPopCurrID;
            break;

        case rcc.vitASuppCurrID :
            targPopCurrID = rcc.infants6t59MoSurveyedTargPopCurrID;
            break;

        case rcc.introSolidSoftFoodsCurrID :
            targPopCurrID = rcc.infants6t8MoSurveyedTargPopCurrID;
            break;

        case rcc.minDietDiversityCurrID :
            targPopCurrID = rcc.infants6t23MoSurveyedTargPopCurrID;
            break;

        case rcc.minMealFrequencyCurrID :
            targPopCurrID = rcc.infants6t23MoSurveyedTargPopCurrID;
            break;

        case rcc.minAcceptableDietCurrID :
            targPopCurrID = rcc.infants6t23MoSurveyedTargPopCurrID;
            break;

        case rcc.underweightPrevChildrenCurrID :
            targPopCurrID = rcc.childrenU5TargPopCurrID;
            break;

        case rcc.stuntingPrevChildrenCurrID :
            targPopCurrID = rcc.childrenU5TargPopCurrID;
            break;

        case rcc.wastingPrevChildrenCurrID :
            targPopCurrID = rcc.childrenU5TargPopCurrID;
            break;

        case rcc.overweightPrevChildrenCurrID :
            targPopCurrID = rcc.childrenU5TargPopCurrID;
            break;

        case rcc.availITNsCurrID :
            targPopCurrID = rcc.HHInterviewedTargPopCurrID;
            break;

        case rcc.ITN_HH_CovCurrID :
            targPopCurrID = rcc.membersInterviewedHHTargPopCurrID;
            break;

        case rcc.IRS_CurrID :
            targPopCurrID = rcc.HHInterviewedTargPopCurrID;
            break;

        case rcc.impDrinkWaterSrcCurrID :
            targPopCurrID = rcc.HHInterviewedTargPopCurrID;
            break;

        case rcc.impDrinkWaterSrcHH_CovCurrID :
            targPopCurrID = rcc.membersInterviewedHHTargPopCurrID;
            break;

        case rcc.impSanitFacilCurrID :
            targPopCurrID = rcc.HHInterviewedTargPopCurrID;
            break;

        case rcc.impSaniFacil_HH_CovCurrID :
            targPopCurrID = rcc.membersInterviewedHHTargPopCurrID;
            break;

        case rcc.safeDisposalChildStoolsCurrID :
            targPopCurrID = rcc.caretakersDispChildrenStoolsTargPopCurrID;
            break;

        case rcc.wealthIdxQuintileCurrID :
            targPopCurrID = rcc.HHInterviewedTargPopCurrID;
            break;

        case rcc.birthRegistrationCurrID :
            targPopCurrID = rcc.childrenU5TargPopCurrID;
            break;

        case rcc.earlyFirstMarriageUnionCurrID :
            targPopCurrID = rcc.women20t24TargPopCurrID;
            break;

        case rcc.youngW_MarriedUnionCurrID :
            targPopCurrID = rcc.womenTargPopCurrID;
            break;

        case rcc.earlyChildbearingCurrID :
            targPopCurrID = rcc.women20t24TargPopCurrID;
            break;

        case rcc.prevFGM_W_CurrID :
            targPopCurrID = rcc.women15t49TargPopCurrID;
            break;

        case rcc.prevFGM_GirlsCurrID :
            targPopCurrID = rcc.daughters0t14TargPopCurrID;
            break;

        case rcc.multiSexPartnersCurrID :
            targPopCurrID = rcc.peopleTargPopCurrID;
            break;

        case rcc.condomUseLastSexMultiSexPartnersCurrID :
            targPopCurrID = rcc.peopleMultiSexPartnersTargPopCurrID;
            break;

        case rcc.sexNonRegPartnersCurrID :
            targPopCurrID = rcc.peopleHadSexTargPopCurrID;
            break;

        case rcc.condomUseNonRegPartnersCurrID :
            targPopCurrID = rcc.peopleHadSexNonMarCohabPartnerTargPopCurrID;
            break;

        case rcc.neverMarriedChildrenNotSexActiveCurrID :
            targPopCurrID = rcc.peopleNeverMarriedTargPopCurrID;
            break;

        case rcc.sexBefore15YrsCurrID :
            targPopCurrID = rcc.people15t24TargPopCurrID;
            break;

        case rcc.sexActiveChildrenPastYearCurrID :
            targPopCurrID = rcc.peopleTargPopCurrID;
            break;

        case rcc.HIV_TestLast12MoResultsKnownCurrID :
            targPopCurrID = rcc.peopleTestedHIVTargPopCurrID;
            break;

        case rcc.employmentLast7DaysCurrID :
            targPopCurrID = rcc.people15t49TargPopCurrID;
            break;

        case rcc.employmentLast12MoCurrID :
            targPopCurrID = rcc.people15t49TargPopCurrID;
            break;

        case rcc.cashEarningsCurrID :
            targPopCurrID = rcc.people15t49TargPopCurrID;
            break;

        case rcc.bankAccountsCurrID :
            targPopCurrID = rcc.people15t49TargPopCurrID;
            break;

        case rcc.ownershipMobilePhonesCurrID :
            targPopCurrID = rcc.people15t49TargPopCurrID;
            break;

        case rcc.mobilePhoneFinancTransactionsCurrID :
            targPopCurrID = rcc.people15t49TargPopCurrID;
            break;

        case rcc.ctrlOverOwnIncomeCurrID :
            targPopCurrID = rcc.people15t49TargPopCurrID;
            break;

        case rcc.ctrlOverPartnerEarningsCurrID :
            targPopCurrID = rcc.peopleMarCohabPartnerUnionTargPopCurrID;
            break;

        case rcc.decisMakingOwnHlthCareCurrID :
            targPopCurrID = rcc.people15t49TargPopCurrID;
            break;

        case rcc.leavHouseWCurrID :
            targPopCurrID = rcc.women15t49TargPopCurrID;
            break;

        default :
            targPopCurrID = 0;
            break;

    }

    return targPopCurrID;

}

/* This method can be used to convert from the target population
   current ID to the indicator current ID for custom indicators, which can assume any of the
   default target populations.

   Methods like "getDefIndAgeLowerBoundStart" take a default indicator current ID instead of a
   target population current ID because default indicators each have one immutable target
   population and we just happened to pick the indicator current ID as the parameter instead of the target
   population current ID. It would be preferrable to change each method to take a target
   population ID instead, but that would take some time, so we made this mapping function.

   It would be nice to remove this function and change the parameters from indicator to target
   population current IDs instead if we ever get the time. */
export function getDefIndCurrIDFromTargPopCurrID(defTargPopCurrID) {

    let indCurrID;

    switch (defTargPopCurrID) {

        case rcc.womenInUnionOrSexActiveTargPopCurrID :
            indCurrID = rcc.demandFamPlanSatCurrID;
            break;

        // case c.womenInUnionOrSexActiveTargPopCurrID :
        //     indCurrID = c.CPR_CurrID;
        //     break;
        //
        // case c.womenInUnionOrSexActiveTargPopCurrID :
        //     indCurrID = c.usingContraceptCurrID;
        //     break;
        //
        // case c.womenInUnionOrSexActiveTargPopCurrID :
        //     indCurrID = c.famPlanDiscCurrID;
        //     break;

        case rcc.womenWithLiveBirthTargPopCurrID :
            indCurrID = rcc.ANC_CurrID;
            break;

        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.contentANC_CurrID;
        //     break;
        //
        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.accompANC_VisitCurrID;
        //     break;
        //
        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.partnerANC_ConsultCurrID;
        //     break;
        //
        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.HIV_TestANCCurrID;
        //     break;
        //
        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.HIV_CounsANCCurrID;
        //     break;
        //
        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.ITN_CovPregWCurrID;
        //     break;
        //
        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.IPTpCurrID;
        //     break;
        //
        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.ironAcidFolicSuppPregWCurrID;
        //     break;
        //
        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.neonatalTetanusProtectPregWCurrID;
        //     break;
        //
        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.SBA_CurrID;
        //     break;
        //
        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.institutionalDelivCurrID;
        //     break;
        //
        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.partnerLabourDeliveryCurrID;
        //     break;
        //
        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.C_SectionCurrID;
        //     break;
        //
        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.postnatalVisitMotherCurrID;
        //     break;
        //
        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.postnatalVisitNewbornCurrID;
        //     break;
        //
        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.thermalCordCareCurrID;
        //     break;
        //
        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.skinToSkinCareCurrID;
        //     break;

        case rcc.infantsSurveyedTargPopCurrID :
            indCurrID = rcc.BCG_CurrID;
            break;

        // case c.infantsSurveyedTargPopCurrID :
        //     indCurrID = c.measlesImmunCurrID;
        //     break;
        //
        // case c.infantsSurveyedTargPopCurrID :
        //     indCurrID = c.pentaDPT3ImmunCurrID;
        //     break;
        //
        // case c.infantsSurveyedTargPopCurrID :
        //     indCurrID = c.pneumoImmunCurrID;
        //     break;
        //
        // case c.infantsSurveyedTargPopCurrID :
        //     indCurrID = c.rotavirusImmunCurrID;
        //     break;

        case rcc.childrenU5SleptHouseTargPopCurrID :
            indCurrID = rcc.ITN_ChildrenU5CurrID;
            break;

        case rcc.childrenU5TargPopCurrID :
            indCurrID = rcc.episodeFeverCurrID;
            break;

        // case c.childrenU5TargPopCurrID :
        //     indCurrID = c.episodeDiarCurrID;
        //     break;
        //
        // case c.childrenU5TargPopCurrID :
        //     indCurrID = c.episodeSuspectPneumCurrID;
        //     break;

        case rcc.childrenU5Fever2WksTargPopCurrID :
            indCurrID = rcc.careSeekFeverCurrID;
            break;

        case rcc.childrenU5Fever2WksDrugsTargPopCurrID :
            indCurrID = rcc.malariaFirstLineTreatmentCurrID;
            break;

        case rcc.childrenU5Diar2WksTargPopCurrID :
            indCurrID = rcc.careSeekDiarCurrID;
            break;

        case rcc.childrenU5Pneum2WksTargPopCurrID :
            indCurrID = rcc.careSeekSuspectPneumCurrID;
            break;

        // case c.childrenU5Diar2WksTargPopCurrID :
        //     indCurrID = c.ORS_TreatDiarCurrID;
        //     break;
        //
        // case c.childrenU5Diar2WksTargPopCurrID :
        //     indCurrID = c.zincTreatDiarCurrID;
        //     break;
        //
        // case c.childrenU5Diar2WksTargPopCurrID:
        //     indCurrID =  c.ORS_ZincTreatDiarCurrID;
        //     break;

        // case c.childrenU5Fever2WksTargPopCurrID :
        //     indCurrID = c.antimalarialTreatCurrID;
        //     break;

        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.childEverBreastfedCurrID;
        //     break;

        // case c.childrenU5TargPopCurrID :
        //     indCurrID = c.exclBF_LT6MoCurrID;
        //     break;

        // case c.womenWithLiveBirthTargPopCurrID :
        //     indCurrID = c.earlyInitBFCurrID;
        //     break;

        case rcc.infants12t15MoSurveyedTargPopCurrID :
            indCurrID = rcc.contBF_At1YrCurrID;
            break;

        case rcc.infants20t23MoSurveyedTargPopCurrID :
            indCurrID = rcc.contBF_At2YrCurrID;
            break;

        // case c.infants6t23MoSurveyedTargPopCurrID :
        //     indCurrID = c.apprFeedPractCurrID;
        //     break;

        case rcc.infants6t59MoSurveyedTargPopCurrID :
            indCurrID = rcc.vitASuppCurrID;
            break;

        case rcc.infants6t8MoSurveyedTargPopCurrID :
            indCurrID = rcc.introSolidSoftFoodsCurrID;
            break;

        case rcc.infants6t23MoSurveyedTargPopCurrID :
            indCurrID = rcc.minDietDiversityCurrID;
            break;

        // case c.infants6t23MoSurveyedTargPopCurrID :
        //     indCurrID = c.minMealFrequencyCurrID;
        //     break;
        //
        // case c.infants6t23MoSurveyedTargPopCurrID :
        //     indCurrID = c.minAcceptableDietCurrID;
        //     break;

        // case c.childrenU5TargPopCurrID :
        //     indCurrID = c.underweightPrevChildrenCurrID;
        //     break;
        //
        // case c.childrenU5TargPopCurrID :
        //     indCurrID = c.stuntingPrevChildrenCurrID;
        //     break;
        //
        // case c.childrenU5TargPopCurrID :
        //     indCurrID = c.wastingPrevChildrenCurrID;
        //     break;
        //
        // case c.childrenU5TargPopCurrID :
        //     indCurrID = c.overweightPrevChildrenCurrID;
        //     break;

        case rcc.HHInterviewedTargPopCurrID :
            indCurrID = rcc.availITNsCurrID;
            break;

        case rcc.HHMembersSleptHouseTargPopCurrID :
            indCurrID = rcc.ITN_HH_CovCurrID;
            break;

        // case c.HHInterviewedTargPopCurrID :
        //     indCurrID = c.IRS_CurrID;
        //     break;
        //
        // case c.HHInterviewedTargPopCurrID :
        //     indCurrID = c.impDrinkWaterSrcCurrID;
        //     break;

        case rcc.membersInterviewedHHTargPopCurrID :
            indCurrID = rcc.impDrinkWaterSrcHH_CovCurrID;
            break;

        // case c.HHInterviewedTargPopCurrID :
        //     indCurrID = c.impSanitFacilCurrID;
        //     break;

        // case c.membersInterviewedHHTargPopCurrID :
        //     indCurrID = c.impSaniFacil_HH_CovCurrID;
        //     break;

        case rcc.caretakersDispChildrenStoolsTargPopCurrID :
            indCurrID = rcc.safeDisposalChildStoolsCurrID;
            break;

        // case c.HHInterviewedTargPopCurrID :
        //     indCurrID = c.wealthIdxQuintileCurrID;
        //     break;

        // case c.childrenU5TargPopCurrID :
        //     indCurrID = c.birthRegistrationCurrID;
        //     break;

        case rcc.women20t24TargPopCurrID :
            indCurrID = rcc.earlyFirstMarriageUnionCurrID;
            break;

        case rcc.womenTargPopCurrID :
            indCurrID = rcc.youngW_MarriedUnionCurrID;
            break;

        // case c.women20t24TargPopCurrID :
        //     indCurrID = c.earlyChildbearingCurrID;
        //     break;

        case rcc.women15t49TargPopCurrID :
            indCurrID = rcc.prevFGM_W_CurrID;
            break;

        case rcc.daughters0t14TargPopCurrID :
            indCurrID = rcc.prevFGM_GirlsCurrID;
            break;

        case rcc.peopleTargPopCurrID :
            indCurrID = rcc.multiSexPartnersCurrID;
            break;

        case rcc.peopleMultiSexPartnersTargPopCurrID :
            indCurrID = rcc.condomUseLastSexMultiSexPartnersCurrID;
            break;

        case rcc.peopleHadSexTargPopCurrID :
            indCurrID = rcc.sexNonRegPartnersCurrID;
            break;

        case rcc.peopleHadSexNonMarCohabPartnerTargPopCurrID :
            indCurrID = rcc.condomUseNonRegPartnersCurrID;
            break;

        case rcc.peopleNeverMarriedTargPopCurrID :
            indCurrID = rcc.neverMarriedChildrenNotSexActiveCurrID;
            break;

        case rcc.people15t24TargPopCurrID :
            indCurrID = rcc.sexBefore15YrsCurrID;
            break;

        // case c.peopleTargPopCurrID :
        //     indCurrID = c.sexActiveChildrenPastYearCurrID;
        //     break;

        case rcc.peopleTestedHIVTargPopCurrID :
            indCurrID = rcc.HIV_TestLast12MoResultsKnownCurrID;
            break;

        case rcc.people15t49TargPopCurrID :
            indCurrID = rcc.employmentLast7DaysCurrID;
            break;

        // case c.people15t49TargPopCurrID :
        //     indCurrID = c.employmentLast12MoCurrID;
        //     break;
        //
        // case c.people15t49TargPopCurrID :
        //     indCurrID = c.cashEarningsCurrID;
        //     break;
        //
        // case c.people15t49TargPopCurrID :
        //     indCurrID = c.bankAccountsCurrID;
        //     break;
        //
        // case c.people15t49TargPopCurrID :
        //     indCurrID = c.ownershipMobilePhonesCurrID;
        //     break;
        //
        // case c.people15t49TargPopCurrID :
        //     indCurrID = c.mobilePhoneFinancTransactionsCurrID;
        //     break;
        //
        // case c.people15t49TargPopCurrID :
        //     indCurrID = c.ctrlOverOwnIncomeCurrID;
        //     break;

        case rcc.peopleMarCohabPartnerUnionTargPopCurrID :
            indCurrID = rcc.ctrlOverPartnerEarningsCurrID;
            break;

        // case c.people15t49TargPopCurrID :
        //     indCurrID = c.decisMakingOwnHlthCareCurrID;
        //     break;

        // case c.women15t49TargPopCurrID :
        //     indCurrID = c.leavHouseWCurrID;
        //     break;

        default :
            indCurrID = 0;
            break;

    }

    return indCurrID;

}

export function getDefGroupCurrID(defIndCurrID) {

    let groupCurrID;

    switch (defIndCurrID) {

        case rcc.demandFamPlanSatCurrID :
            groupCurrID = rcc.famPlanGroupCurrID;
            break;

        case rcc.CPR_CurrID :
            groupCurrID = rcc.famPlanGroupCurrID;
            break;

        case rcc.usingContraceptCurrID :
            groupCurrID = rcc.famPlanGroupCurrID;
            break;

        case rcc.famPlanDiscCurrID :
            groupCurrID = rcc.famPlanGroupCurrID;
            break;

        case rcc.ANC_CurrID :
            groupCurrID = rcc.antenatalCareGroupCurrID;
            break;

        case rcc.contentANC_CurrID :
            groupCurrID = rcc.antenatalCareGroupCurrID;
            break;

        case rcc.accompANC_VisitCurrID :
            groupCurrID = rcc.antenatalCareGroupCurrID;
            break;

        case rcc.partnerANC_ConsultCurrID :
            groupCurrID = rcc.antenatalCareGroupCurrID;
            break;

        case rcc.HIV_TestANCCurrID :
            groupCurrID = rcc.antenatalCareGroupCurrID;
            break;

        case rcc.HIV_CounsANCCurrID :
            groupCurrID = rcc.antenatalCareGroupCurrID;
            break;

        case rcc.ITN_CovPregWCurrID :
            groupCurrID = rcc.antenatalCareGroupCurrID;
            break;

        case rcc.IPTpCurrID :
            groupCurrID = rcc.antenatalCareGroupCurrID;
            break;

        case rcc.ironAcidFolicSuppPregWCurrID :
            groupCurrID = rcc.antenatalCareGroupCurrID;
            break;

        case rcc.neonatalTetanusProtectPregWCurrID :
            groupCurrID = rcc.antenatalCareGroupCurrID;
            break;

        case rcc.SBA_CurrID :
            groupCurrID = rcc.delivChildbirthGroupCurrID;
            break;

        case rcc.institutionalDelivCurrID :
            groupCurrID = rcc.delivChildbirthGroupCurrID;
            break;

        case rcc.partnerLabourDeliveryCurrID :
            groupCurrID = rcc.delivChildbirthGroupCurrID;
            break;

        case rcc.C_SectionCurrID :
            groupCurrID = rcc.delivChildbirthGroupCurrID;
            break;

        case rcc.postnatalVisitMotherCurrID :
            groupCurrID = rcc.postnatalCareGroupCurrID;
            break;

        case rcc.postnatalVisitNewbornCurrID :
            groupCurrID = rcc.postnatalCareGroupCurrID;
            break;

        case rcc.thermalCordCareCurrID :
            groupCurrID = rcc.postnatalCareGroupCurrID;
            break;

        case rcc.skinToSkinCareCurrID :
            groupCurrID = rcc.postnatalCareGroupCurrID;
            break;

        case rcc.BCG_CurrID :
            groupCurrID = rcc.childHlthPrevGroupCurrID;
            break;

        case rcc.measlesImmunCurrID :
            groupCurrID = rcc.childHlthPrevGroupCurrID;
            break;

        case rcc.pentaDPT3ImmunCurrID :
            groupCurrID = rcc.childHlthPrevGroupCurrID;
            break;

        case rcc.pneumoImmunCurrID :
            groupCurrID = rcc.childHlthPrevGroupCurrID;
            break;

        case rcc.rotavirusImmunCurrID :
            groupCurrID = rcc.childHlthPrevGroupCurrID;
            break;

        case rcc.ITN_ChildrenU5CurrID :
            groupCurrID = rcc.childHlthPrevGroupCurrID;
            break;

        case rcc.episodeFeverCurrID :
            groupCurrID = rcc.childHlthCurGroupCurrID;
            break;

        case rcc.episodeDiarCurrID :
            groupCurrID = rcc.childHlthCurGroupCurrID;
            break;

        case rcc.episodeSuspectPneumCurrID :
            groupCurrID = rcc.childHlthCurGroupCurrID;
            break;

        case rcc.careSeekFeverCurrID :
            groupCurrID = rcc.childHlthCurGroupCurrID;
            break;

        case rcc.malariaFirstLineTreatmentCurrID :
            groupCurrID = rcc.childHlthCurGroupCurrID;
            break;

        case rcc.careSeekDiarCurrID :
            groupCurrID = rcc.childHlthCurGroupCurrID;
            break;

        case rcc.careSeekSuspectPneumCurrID :
            groupCurrID = rcc.childHlthCurGroupCurrID;
            break;

        case rcc.ORS_TreatDiarCurrID :
            groupCurrID = rcc.childHlthCurGroupCurrID;
            break;

        case rcc.zincTreatDiarCurrID :
            groupCurrID = rcc.childHlthCurGroupCurrID;
            break;

        case rcc.ORS_ZincTreatDiarCurrID :
            groupCurrID = rcc.childHlthCurGroupCurrID;
            break;

        case rcc.antimalarialTreatCurrID :
            groupCurrID = rcc.childHlthCurGroupCurrID;
            break;

        case rcc.childEverBreastfedCurrID :
            groupCurrID = rcc.nutritionGroupCurrID;
            break;

        case rcc.exclBF_LT6MoCurrID :
            groupCurrID = rcc.nutritionGroupCurrID;
            break;

        case rcc.earlyInitBFCurrID :
            groupCurrID = rcc.nutritionGroupCurrID;
            break;

        case rcc.contBF_At1YrCurrID :
            groupCurrID = rcc.nutritionGroupCurrID;
            break;

        case rcc.contBF_At2YrCurrID :
            groupCurrID = rcc.nutritionGroupCurrID;
            break;

        case rcc.apprFeedPractCurrID :
            groupCurrID = rcc.nutritionGroupCurrID;
            break;

        case rcc.vitASuppCurrID :
            groupCurrID = rcc.nutritionGroupCurrID;
            break;

        case rcc.introSolidSoftFoodsCurrID :
            groupCurrID = rcc.nutritionGroupCurrID;
            break;

        case rcc.minDietDiversityCurrID :
            groupCurrID = rcc.nutritionGroupCurrID;
            break;

        case rcc.minMealFrequencyCurrID :
            groupCurrID = rcc.nutritionGroupCurrID;
            break;

        case rcc.minAcceptableDietCurrID :
            groupCurrID = rcc.nutritionGroupCurrID;
            break;

        case rcc.underweightPrevChildrenCurrID :
            groupCurrID = rcc.nutritionImpactGroupCurrID;
            break;

        case rcc.stuntingPrevChildrenCurrID :
            groupCurrID = rcc.nutritionImpactGroupCurrID;
            break;

        case rcc.wastingPrevChildrenCurrID :
            groupCurrID = rcc.nutritionImpactGroupCurrID;
            break;

        case rcc.overweightPrevChildrenCurrID :
            groupCurrID = rcc.nutritionImpactGroupCurrID;
            break;

        case rcc.availITNsCurrID :
            groupCurrID = rcc.vectorCtrlGroupCurrID;
            break;

        case rcc.ITN_HH_CovCurrID :
            groupCurrID = rcc.vectorCtrlGroupCurrID;
            break;

        case rcc.IRS_CurrID :
            groupCurrID = rcc.vectorCtrlGroupCurrID;
            break;

        case rcc.impDrinkWaterSrcCurrID :
            groupCurrID = rcc.waterSanitGroupCurrID;
            break;

        case rcc.impDrinkWaterSrcHH_CovCurrID :
            groupCurrID = rcc.waterSanitGroupCurrID;
            break;

        case rcc.impSanitFacilCurrID :
            groupCurrID = rcc.waterSanitGroupCurrID;
            break;

        case rcc.impSaniFacil_HH_CovCurrID :
            groupCurrID = rcc.waterSanitGroupCurrID;
            break;

        case rcc.safeDisposalChildStoolsCurrID :
            groupCurrID = rcc.waterSanitGroupCurrID;
            break;

        case rcc.wealthIdxQuintileCurrID :
            groupCurrID = rcc.povertyGroupCurrID;
            break;

        case rcc.birthRegistrationCurrID :
            groupCurrID = rcc.childProtectGroupCurrID;
            break;

        case rcc.earlyFirstMarriageUnionCurrID :
            groupCurrID = rcc.childProtectGroupCurrID;
            break;

        case rcc.youngW_MarriedUnionCurrID :
            groupCurrID = rcc.childProtectGroupCurrID;
            break;

        case rcc.earlyChildbearingCurrID :
            groupCurrID = rcc.childProtectGroupCurrID;
            break;

        case rcc.prevFGM_W_CurrID :
            groupCurrID = rcc.childProtectGroupCurrID;
            break;

        case rcc.prevFGM_GirlsCurrID :
            groupCurrID = rcc.childProtectGroupCurrID;
            break;

        case rcc.multiSexPartnersCurrID :
            groupCurrID = rcc.sexBehavGroupCurrID;
            break;

        case rcc.condomUseLastSexMultiSexPartnersCurrID :
            groupCurrID = rcc.sexBehavGroupCurrID;
            break;

        case rcc.sexNonRegPartnersCurrID :
            groupCurrID = rcc.sexBehavGroupCurrID;
            break;

        case rcc.condomUseNonRegPartnersCurrID :
            groupCurrID = rcc.sexBehavGroupCurrID;
            break;

        case rcc.neverMarriedChildrenNotSexActiveCurrID :
            groupCurrID = rcc.sexBehavGroupCurrID;
            break;

        case rcc.sexBefore15YrsCurrID :
            groupCurrID = rcc.sexBehavGroupCurrID;
            break;

        case rcc.sexActiveChildrenPastYearCurrID :
            groupCurrID = rcc.sexBehavGroupCurrID;
            break;

        case rcc.HIV_TestLast12MoResultsKnownCurrID :
            groupCurrID = rcc.sexHlthGroupCurrID;
            break;

        case rcc.employmentLast7DaysCurrID :
            groupCurrID = rcc.genderEmpowerGroupCurrID;
            break;

        case rcc.employmentLast12MoCurrID :
            groupCurrID = rcc.genderEmpowerGroupCurrID;
            break;

        case rcc.cashEarningsCurrID :
            groupCurrID = rcc.genderEmpowerGroupCurrID;
            break;

        case rcc.bankAccountsCurrID :
            groupCurrID = rcc.genderEmpowerGroupCurrID;
            break;

        case rcc.ownershipMobilePhonesCurrID :
            groupCurrID = rcc.genderEmpowerGroupCurrID;
            break;

        case rcc.mobilePhoneFinancTransactionsCurrID :
            groupCurrID = rcc.genderEmpowerGroupCurrID;
            break;

        case rcc.ctrlOverOwnIncomeCurrID :
            groupCurrID = rcc.genderEmpowerGroupCurrID;
            break;

        case rcc.ctrlOverPartnerEarningsCurrID :
            groupCurrID = rcc.genderEmpowerGroupCurrID;
            break;

        case rcc.decisMakingOwnHlthCareCurrID :
            groupCurrID = rcc.genderEmpowerGroupCurrID;
            break;

        case rcc.leavHouseWCurrID :
            groupCurrID = rcc.genderEmpowerGroupCurrID;
            break;

        default :
            groupCurrID = 0;
            break;

    }

    return groupCurrID;

}

export function getDefEstFreq(defIndCurrID) {

    let value;

    switch (defIndCurrID) {

        default :
            value = 50;
            break;

    }

    return value;

}

export function getDefDesiredPrec(defIndCurrID) {

    let value;

    switch (defIndCurrID) {

        default :
            value = 0;
            break;

    }

    return value;

}
    
export function getDefDesignEffect(defIndCurrID) {

    let value;

    switch (defIndCurrID) {

        default :
            value = 2;
            break;

    }

    return value;

}

export function getDefTargPopName(targPopCurrID) {

    let targPopName;

    switch (targPopCurrID) {

        case rcc.womenInUnionOrSexActiveTargPopCurrID :
            targPopName = RS(SC.GB_stWomenInUnionOrSexActiveTargPop);
            break;

        case rcc.womenWithLiveBirthTargPopCurrID :
            targPopName = RS(SC.GB_stWomenWithLiveBirthTargPop);
            break;

        case rcc.infantsSurveyedTargPopCurrID :
            targPopName = RS(SC.GB_stInfantsSurveyedTargPop);
            break;

        case rcc.childrenU5SleptHouseTargPopCurrID :
            targPopName = RS(SC.GB_stChildrenU5SleptHouseTargPop);
            break;

        case rcc.childrenU5TargPopCurrID :
            targPopName = RS(SC.GB_stChildrenU5TargPop);
            break;

        case rcc.childrenU5Fever2WksTargPopCurrID :
            targPopName = RS(SC.GB_stChildrenU5Fever2WksTargPop);
            break;

        case rcc.childrenU5Fever2WksDrugsTargPopCurrID :
            targPopName = RS(SC.GB_stChildrenU5Fever2WksDrugsTargPop);
            break;

        case rcc.childrenU5Diar2WksTargPopCurrID :
            targPopName = RS(SC.GB_stChildrenU5Diar2WksTargPop);
            break;

        case rcc.childrenU5Pneum2WksTargPopCurrID :
            targPopName = RS(SC.GB_stChildrenU5Pneum2WksTargPop);
            break;

        case rcc.HHInterviewedTargPopCurrID :
            targPopName = RS(SC.GB_stHHInterviewedTargPop);
            break;

        case rcc.HHMembersSleptHouseTargPopCurrID :
            targPopName = RS(SC.GB_stHHMembersSleptHouseTargPop);
            break;

        case rcc.membersInterviewedHHTargPopCurrID :
            targPopName = RS(SC.GB_stMembersInterviewedHHTargPop);
            break;

        case rcc.caretakersDispChildrenStoolsTargPopCurrID :
            targPopName = RS(SC.GB_stCaretakersDispChildrenStoolsTargPop);
            break;

        case rcc.womenTargPopCurrID :
            targPopName = RS(SC.GB_stWomenTargPop);
            break;

        case rcc.daughters0t14TargPopCurrID :
            targPopName = RS(SC.GB_stDaughters0t14TargPop);
            break;

        case rcc.peopleTargPopCurrID :
            targPopName = RS(SC.GB_stPeopleTargPop);
            break;

        case rcc.peopleMultiSexPartnersTargPopCurrID :
            targPopName = RS(SC.GB_stPeopleMultiSexPartnersTargPop);
            break;

        case rcc.peopleHadSexTargPopCurrID :
            targPopName = RS(SC.GB_stPeopleHadSexTargPop);
            break;

        case rcc.peopleHadSexNonMarCohabPartnerTargPopCurrID :
            targPopName = RS(SC.GB_stPeopleHadSexNonMarCohabPartnerTargPop);
            break;

        case rcc.peopleNeverMarriedTargPopCurrID :
            targPopName = RS(SC.GB_stPeopleNeverMarriedTargPop);
            break;

        case rcc.peopleTestedHIVTargPopCurrID :
            targPopName = RS(SC.GB_stPeopleTestedHIVTargPop);
            break;

        case rcc.peopleMarCohabPartnerUnionTargPopCurrID :
            targPopName = RS(SC.GB_stPeopleMarCohabPartnerUnionTargPop);
            break;

        case rcc.infants12t15MoSurveyedTargPopCurrID :
            targPopName = RS(SC.GB_stInfants12t15MoSurveyedTargPop);
            break;

        case rcc.infants20t23MoSurveyedTargPopCurrID :
            targPopName = RS(SC.GB_stInfants20t23MoSurveyedTargPop);
            break;

        case rcc.infants6t23MoSurveyedTargPopCurrID :
            targPopName = RS(SC.GB_stInfants6t23MoSurveyedTargPop);
            break;

        case rcc.infants6t59MoSurveyedTargPopCurrID :
            targPopName = RS(SC.GB_stInfants6t59MoSurveyedTargPop);
            break;

        case rcc.infants6t8MoSurveyedTargPopCurrID :
            targPopName = RS(SC.GB_stInfants6t8MoSurveyedTargPop);
            break;

        case rcc.women20t24TargPopCurrID :
            targPopName = RS(SC.GB_stWomen20t24TargPop);
            break;

        case rcc.women15t49TargPopCurrID :
            targPopName = RS(SC.GB_stWomen15t49TargPop);
            break;

        case rcc.people15t24TargPopCurrID :
            targPopName = RS(SC.GB_stPeople15t24TargPop);
            break;

        case rcc.people15t49TargPopCurrID :
            targPopName = RS(SC.GB_stPeople15t49TargPop);
            break;

        default :
            targPopName = "";
            break;

    }

    return targPopName;

}

export function getDefTargPopMstID(targPopCurrID) {

    let indMstID;

    switch (targPopCurrID) {

        case rcc.womenInUnionOrSexActiveTargPopCurrID :
            indMstID = rcc.womenInUnionOrSexActiveTargPopMstID;
            break;

        case rcc.womenWithLiveBirthTargPopCurrID :
            indMstID = rcc.womenWithLiveBirthTargPopMstID;
            break;

        case rcc.infantsSurveyedTargPopCurrID :
            indMstID = rcc.infantsSurveyedTargPopMstID;
            break;

        case rcc.childrenU5SleptHouseTargPopCurrID :
            indMstID = rcc.childrenU5SleptHouseTargPopMstID;
            break;

        case rcc.childrenU5TargPopCurrID :
            indMstID = rcc.childrenU5TargPopMstID;
            break;

        case rcc.childrenU5Fever2WksTargPopCurrID :
            indMstID = rcc.childrenU5Fever2WksTargPopMstID;
            break;

        case rcc.childrenU5Fever2WksDrugsTargPopCurrID :
            indMstID = rcc.childrenU5Fever2WksDrugsTargPopMstID;
            break;

        case rcc.childrenU5Diar2WksTargPopCurrID :
            indMstID = rcc.childrenU5Diar2WksTargPopMstID;
            break;

        case rcc.childrenU5Pneum2WksTargPopCurrID :
            indMstID = rcc.childrenU5Pneum2WksTargPopMstID;
            break;

        case rcc.HHInterviewedTargPopCurrID :
            indMstID = rcc.HHInterviewedTargPopMstID;
            break;

        case rcc.HHMembersSleptHouseTargPopCurrID :
            indMstID = rcc.HHMembersSleptHouseTargPopMstID;
            break;

        case rcc.membersInterviewedHHTargPopCurrID :
            indMstID = rcc.membersInterviewedHHTargPopMstID;
            break;

        case rcc.caretakersDispChildrenStoolsTargPopCurrID :
            indMstID = rcc.caretakersDispChildrenStoolsTargPopMstID;
            break;

        case rcc.womenTargPopCurrID :
            indMstID = rcc.womenTargPopMstID;
            break;

        case rcc.daughters0t14TargPopCurrID :
            indMstID = rcc.daughters0t14TargPopMstID;
            break;

        case rcc.peopleTargPopCurrID :
            indMstID = rcc.peopleTargPopMstID;
            break;

        case rcc.peopleMultiSexPartnersTargPopCurrID :
            indMstID = rcc.peopleMultiSexPartnersTargPopMstID;
            break;

        case rcc.peopleHadSexTargPopCurrID :
            indMstID = rcc.peopleHadSexTargPopMstID;
            break;

        case rcc.peopleHadSexNonMarCohabPartnerTargPopCurrID :
            indMstID = rcc.peopleHadSexNonMarCohabPartnerTargPopMstID;
            break;

        case rcc.peopleNeverMarriedTargPopCurrID :
            indMstID = rcc.peopleNeverMarriedTargPopMstID;
            break;

        case rcc.peopleTestedHIVTargPopCurrID :
            indMstID = rcc.peopleTestedHIVTargPopMstID;
            break;

        case rcc.peopleMarCohabPartnerUnionTargPopCurrID :
            indMstID = rcc.peopleMarCohabPartnerUnionTargPopMstID;
            break;

        case rcc.infants12t15MoSurveyedTargPopCurrID :
            indMstID = rcc.infants12t15MoSurveyedTargPopMstID;
            break;

        case rcc.infants20t23MoSurveyedTargPopCurrID :
            indMstID = rcc.infants20t23MoSurveyedTargPopMstID;
            break;

        case rcc.infants6t23MoSurveyedTargPopCurrID :
            indMstID = rcc.infants6t23MoSurveyedTargPopMstID;
            break;

        case rcc.infants6t59MoSurveyedTargPopCurrID :
            indMstID = rcc.infants6t59MoSurveyedTargPopMstID;
            break;

        case rcc.infants6t8MoSurveyedTargPopCurrID :
            indMstID = rcc.infants6t8MoSurveyedTargPopMstID;
            break;

        case rcc.women20t24TargPopCurrID :
            indMstID = rcc.women20t24TargPopMstID;
            break;

        case rcc.women15t49TargPopCurrID :
            indMstID = rcc.women15t49TargPopMstID;
            break;

        case rcc.people15t24TargPopCurrID :
            indMstID = rcc.people15t24TargPopMstID;
            break;

        case rcc.people15t49TargPopCurrID :
            indMstID = rcc.people15t49TargPopMstID;
            break;

        default :
            indMstID = 0;
            break;

    }

    return indMstID;

}

export function getDefGroupName(groupCurrID) {

    let groupName;

    switch (groupCurrID) {

        case rcc.famPlanGroupCurrID :
            groupName = RS(SC.GB_stFamPlanGroup);
            break;

        case rcc.antenatalCareGroupCurrID :
            groupName = RS(SC.GB_stAntenatalCareGroup);
            break;

        case rcc.delivChildbirthGroupCurrID :
            groupName = RS(SC.GB_stDelivChildbirthGroup);
            break;

        case rcc.postnatalCareGroupCurrID :
            groupName = RS(SC.GB_stPostnatalCareGroup);
            break;

        case rcc.childHlthPrevGroupCurrID :
            groupName = RS(SC.GB_stChildHlthPrevGroup);
            break;

        case rcc.childHlthCurGroupCurrID :
            groupName = RS(SC.GB_stChildHlthCurGroup);
            break;

        case rcc.nutritionGroupCurrID :
            groupName = RS(SC.GB_stNutritionGroup);
            break;

        case rcc.nutritionImpactGroupCurrID :
            groupName = RS(SC.GB_stNutritionImpactGroup);
            break;

        case rcc.vectorCtrlGroupCurrID :
            groupName = RS(SC.GB_stVectorCtrlGroup);
            break;

        case rcc.waterSanitGroupCurrID :
            groupName = RS(SC.GB_stWaterSanitGroup);
            break;

        case rcc.povertyGroupCurrID :
            groupName = RS(SC.GB_stPovertyGroup);
            break;

        case rcc.childProtectGroupCurrID :
            groupName = RS(SC.GB_stChildProtectGroup);
            break;

        case rcc.sexBehavGroupCurrID :
            groupName = RS(SC.GB_stSexBehavGroup);
            break;

        case rcc.sexHlthGroupCurrID :
            groupName = RS(SC.GB_stSexHlthGroup);
            break;

        case rcc.genderEmpowerGroupCurrID :
            groupName = RS(SC.GB_stGenderEmpowerGroup);
            break;

        case rcc.customIndGroupCurrID :
            groupName = RS(SC.GB_stCustomIndGroup);
            break;

        default :
            groupName = "";
            break;

    }

    return groupName;

}

export function getDefGroupMstID(groupCurrID) {

    let groupMstID;

    switch (groupCurrID) {

        case rcc.famPlanGroupCurrID :
            groupMstID = rcc.famPlanGroupMstID;
            break;

        case rcc.antenatalCareGroupCurrID :
            groupMstID = rcc.antenatalCareGroupMstID;
            break;

        case rcc.delivChildbirthGroupCurrID :
            groupMstID = rcc.delivChildbirthGroupMstID;
            break;

        case rcc.postnatalCareGroupCurrID :
            groupMstID = rcc.postnatalCareGroupMstID;
            break;

        case rcc.childHlthPrevGroupCurrID :
            groupMstID = rcc.childHlthPrevGroupMstID;
            break;

        case rcc.childHlthCurGroupCurrID :
            groupMstID = rcc.childHlthCurGroupMstID;
            break;

        case rcc.nutritionGroupCurrID :
            groupMstID = rcc.nutritionGroupMstID;
            break;

        case rcc.nutritionImpactGroupCurrID :
            groupMstID = rcc.nutritionImpactGroupMstID;
            break;

        case rcc.vectorCtrlGroupCurrID :
            groupMstID = rcc.vectorCtrlGroupMstID;
            break;

        case rcc.waterSanitGroupCurrID :
            groupMstID = rcc.waterSanitGroupMstID;
            break;

        case rcc.povertyGroupCurrID :
            groupMstID = rcc.povertyGroupMstID;
            break;

        case rcc.childProtectGroupCurrID :
            groupMstID = rcc.childProtectGroupMstID;
            break;

        case rcc.sexBehavGroupCurrID :
            groupMstID = rcc.sexBehavGroupMstID;
            break;

        case rcc.sexHlthGroupCurrID :
            groupMstID = rcc.sexHlthGroupMstID;
            break;

        case rcc.genderEmpowerGroupCurrID :
            groupMstID = rcc.genderEmpowerGroupMstID;
            break;

        case rcc.customIndGroupCurrID :
            groupMstID = rcc.customIndGroupMstID;
            break;

        default :
            groupMstID = 0;
            break;

    }

    return groupMstID;

}

export function getDefTargPopParamName(targPopCurrID) {

    let paramName;

    switch (targPopCurrID) {

        case rcc.womenInUnionOrSexActiveTargPopCurrID :
            paramName = RS(SC.GB_stWomenInUnionOrSexActiveTargPopParam);
            break;

        case rcc.womenWithLiveBirthTargPopCurrID :
            paramName = RS(SC.GB_stWomenWithLiveBirthTargPopParam);
            break;

        case rcc.infantsSurveyedTargPopCurrID :
            paramName = RS(SC.GB_stInfantsSurveyedTargPopParam);
            break;

        case rcc.childrenU5SleptHouseTargPopCurrID :
            paramName = RS(SC.GB_stChildrenU5SleptHouseTargPopParam);
            break;

        case rcc.childrenU5TargPopCurrID :
            paramName = RS(SC.GB_stChildrenU5TargPopParam);
            break;

        case rcc.childrenU5Fever2WksTargPopCurrID :
            paramName = RS(SC.GB_stChildrenU5Fever2WksTargPopParam);
            break;

        case rcc.childrenU5Fever2WksDrugsTargPopCurrID :
            paramName = RS(SC.GB_stChildrenU5Fever2WksDrugsTargPopParam);
            break;

        case rcc.childrenU5Diar2WksTargPopCurrID :
            paramName = RS(SC.GB_stChildrenU5Diar2WksTargPopParam);
            break;

        case rcc.childrenU5Pneum2WksTargPopCurrID :
            paramName = RS(SC.GB_stChildrenU5Pneum2WksTargPopParam);
            break;

        case rcc.HHInterviewedTargPopCurrID :
            paramName = RS(SC.GB_stHHInterviewedTargPopParam);
            break;

        case rcc.HHMembersSleptHouseTargPopCurrID :
            paramName = RS(SC.GB_stHHMembersSleptHouseTargPopParam);
            break;

        case rcc.membersInterviewedHHTargPopCurrID :
            paramName = RS(SC.GB_stMembersInterviewedHHTargPopParam);
            break;

        case rcc.caretakersDispChildrenStoolsTargPopCurrID :
            paramName = RS(SC.GB_stCaretakersDispChildrenStoolsTargPopParam);
            break;

        case rcc.womenTargPopCurrID :
            paramName = RS(SC.GB_stWomenTargPopParam);
            break;

        case rcc.daughters0t14TargPopCurrID :
            paramName = RS(SC.GB_stDaughters0t14TargPopParam);
            break;

        case rcc.peopleTargPopCurrID :
            paramName = RS(SC.GB_stPeopleTargPopParam);
            break;

        case rcc.peopleMultiSexPartnersTargPopCurrID :
            paramName = RS(SC.GB_stPeopleMultiSexPartnersTargPopParam);
            break;

        case rcc.peopleHadSexTargPopCurrID :
            paramName = RS(SC.GB_stPeopleHadSexTargPopParam);
            break;

        case rcc.peopleHadSexNonMarCohabPartnerTargPopCurrID :
            paramName = RS(SC.GB_stPeopleHadSexNonMarCohabPartnerTargPopParam);
            break;

        case rcc.peopleNeverMarriedTargPopCurrID :
            paramName = RS(SC.GB_stPeopleNeverMarriedTargPopParam);
            break;

        case rcc.peopleTestedHIVTargPopCurrID :
            paramName = RS(SC.GB_stPeopleTestedHIVTargPopParam);
            break;

        case rcc.peopleMarCohabPartnerUnionTargPopCurrID :
            paramName = RS(SC.GB_stPeopleMarCohabPartnerUnionTargPopParam);
            break;

        case rcc.infants12t15MoSurveyedTargPopCurrID :
            paramName = RS(SC.GB_stInfants12t15MoSurveyedTargPopParam);
            break;

        case rcc.infants20t23MoSurveyedTargPopCurrID :
            paramName = RS(SC.GB_stInfants20t23MoSurveyedTargPopParam);
            break;

        case rcc.infants6t23MoSurveyedTargPopCurrID :
            paramName = RS(SC.GB_stInfants6t23MoSurveyedTargPopParam);
            break;

        case rcc.infants6t59MoSurveyedTargPopCurrID :
            paramName = RS(SC.GB_stInfants6t59MoSurveyedTargPopParam);
            break;

        case rcc.infants6t8MoSurveyedTargPopCurrID :
            paramName = RS(SC.GB_stInfants6t8MoSurveyedTargPopParam);
            break;

        case rcc.women20t24TargPopCurrID :
            paramName = RS(SC.GB_stWomen20t24TargPopParam);
            break;

        case rcc.women15t49TargPopCurrID :
            paramName = RS(SC.GB_stWomen15t49TargPopParam);
            break;

        case rcc.people15t24TargPopCurrID :
            paramName = RS(SC.GB_stPeople15t24TargPopParam);
            break;

        case rcc.people15t49TargPopCurrID :
            paramName = RS(SC.GB_stPeople15t49TargPopParam);
            break;

        default :
            paramName = "";
            break;

    }

    return paramName;

}

export function URL_Click(URL_Str) {

    window.open(URL_Str);

}